import React, { useState, useCallback, useEffect, useRef } from 'react';
import './../../App.css';
import './Employees.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import {CreateButton} from './../CommonObjects';
import { 
  OnBoardingRequirementsSelect,
} from './../../common/APICommon';
import {SetAuditTrail} from './../Reports/AuditTrailReportEmployeeSetup';
import axios from 'axios';
import {token, domain} from './../Security';
import {useTable} from 'react-table';
import loadingSpinner from './../../assets/loading.gif';
import {globalTimeFormat} from './../Security';
import { QRCodeCanvas } from 'qrcode.react';
// icons
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SyncIcon from '@mui/icons-material/Sync';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import DownloadIcon from '@mui/icons-material/Download';
import QrCodeIcon from '@mui/icons-material/QrCode';

function ViewEmployee({
  user,
  isOpen, 
  onClose,
  viewedData,
  setViewedData,
  fetchData,
  employeePhoto,
  setEmployeePhoto
}) {

  // console.log(viewedData)
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const [isFirstPage, setIsFirstPage] = useState(true);
  const [isLastPage, setIsLastPage] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [isOpenOnce, setIsOpenOnce] = useState(false);

  //Personal
  const [employeeId, setEmployeeId] = useState("");
  const [selectedFile, setSelectedFile] = useState("");
  const [lastName, setLastName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [extensionName, setExtensionName] = useState("");
  const [nickName, setNickName] = useState("");
  const [age, setAge] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [placeOfBirth, setPlaceOfBirth] = useState("");
  const [civilStatus, setCivilStatus] = useState("");
  const [bloodType, setBloodType] = useState("");
  const [height, setHeight] = useState("");
  const [weight, setWeight] = useState("");
  const [citizenship, setCitizenship] = useState("");
  const [religion, setReligion] = useState("");
  const [gender, setGender] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [deviceNumber, setDeviceNumber] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [signature, setSignature] = useState([]);
  //Address
  const [blkLot, setBlkLot] = useState("");
  const [street, setStreet] = useState("");
  const [barangay, setBarangay] = useState("");
  const [city, setCity] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [yearsOfStay, setYearsOfStay] = useState("");
  //Information
  const [locationId, setLocationId] = useState("");
  const [dateEmployed, setDateEmployed] = useState("");
  const [dateRegular, setDateRegular] = useState("");
  const [dateProbationary, setDateProbationary] = useState("");
  const [dateProjectBase, setDateProjectBase] = useState("");
  const [dateContractual, setDateContractual] = useState("");
  const [dateResigned, setDateResigned] = useState("");
  const [employmentId, setEmploymentId] = useState("");
  const [departmentId, setDepartmentId] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [classificationId, setClassificationId] = useState("");
  const [payTypeId, setPayTypeId] = useState("");
  const [shiftScheduleId, setShiftScheduleId] = useState("");
  const [positionId, setPositionId] = useState("");
  const [salaryType, setSalaryType] = useState("");
  const [sickLeave, setSickLeave] = useState("");
  const [vacationLeave, setVacationLeave] = useState("");
  const [serviceIncentiveLeave, setServiceIncentiveLeave] = useState("");
  const [soloParentLeave, setSoloParentLeave] = useState("");
  const [sickRemaining, setSickRemaining] = useState("");
  const [vacationRemaining, setVacationRemaining] = useState("");
  const [serviceIncentiveRemaining, setServiceIncentiveRemaining] = useState("");
  const [soloParentRemaining, setSoloParentRemaining] = useState("");
  const [employeeStatus, setEmployeeStatus] = useState("");
  const [jobTitleId, setJobTitleId] = useState("");
  const [employeeGroup1Id, setEmployeeGroup1Id] = useState("");
  const [employeeGroup2Id, setEmployeeGroup2Id] = useState("");
  const [plantilyaId, setPlantilyaId] = useState("");
  const [costCenterId, setCostCenterId] = useState("");
  const [clientId, setClientId] = useState("");
  const [hasMobileRegisterFeature, setHasMobileRegisterFeature] = useState("");
  const [hasMobileInAndOut, setHasMobileInAndOut] = useState("");
  //Accounts
  const [sss, setsss] = useState("");
  const [tin, setTin] = useState("");
  const [passport, setPassport] = useState("");
  const [philhealth, setPhilhealth] = useState("");
  const [pagibig, setPagibig] = useState("");
  //Education
  const [employeeEducationAttainments, setEmployeeEducationAttainments] = useState([]);
  //Dependents
  const [employeeDependents, setEmployeeDependents] = useState([]);
  //Emegency
  const [employeeEmergencyContacts, setEmployeeEmergencyContacts] = useState([]);
  //Family
  const [employeeFamilyData, setEmployeeFamilyData] = useState([]);
  //Restdays
  const [employeeRestDays, setEmployeeRestDays] = useState([]);

  //old values
  const [isInit, setIsInit] = useState(false);
  const [oldEmployeeId, setOldEmployeeId] = useState("");
  const [oldSelectedFile, setOldSelectedFile] = useState("");
  const [oldLastName, setOldLastName] = useState("");
  const [oldFirstName, setOldFirstName] = useState("");
  const [oldMiddleName, setOldMiddleName] = useState("");
  const [oldExtensionName, setOldExtensionName] = useState("");
  const [oldNickName, setOldNickName] = useState("");
  const [oldAge, setOldAge] = useState("");
  const [oldDateOfBirth, setOldDateOfBirth] = useState("");
  const [oldPlaceOfBirth, setOldPlaceOfBirth] = useState("");
  const [oldCivilStatus, setOldCivilStatus] = useState("");
  const [oldBloodType, setOldBloodType] = useState("");
  const [oldHeight, setOldHeight] = useState("");
  const [oldWeight, setOldWeight] = useState("");
  const [oldCitizenship, setOldCitizenship] = useState("");
  const [oldReligion, setOldReligion] = useState("");
  const [oldGender, setOldGender] = useState("");
  const [oldMobileNumber, setOldMobileNumber] = useState("");
  const [oldEmailAddress, setOldEmailAddress] = useState("");
  const [oldDeviceNumber, setOldDeviceNumber] = useState("");
  const [oldCompanyId, setOldCompanyId] = useState("");

  // Address
  const [oldBlkLot, setOldBlkLot] = useState("");
  const [oldStreet, setOldStreet] = useState("");
  const [oldBarangay, setOldBarangay] = useState("");
  const [oldCity, setOldCity] = useState("");
  const [oldPostalCode, setOldPostalCode] = useState("");
  const [oldYearsOfStay, setOldYearsOfStay] = useState("");

  // Information
  const [oldLocationId, setOldLocationId] = useState("");
  const [oldDateEmployed, setOldDateEmployed] = useState("");
  const [oldDateRegular, setOldDateRegular] = useState("");
  const [oldDateProbationary, setOldDateProbationary] = useState("");
  const [oldDateProjectBase, setOldDateProjectBase] = useState("");
  const [oldDateContractual, setOldDateContractual] = useState("");
  const [oldEmploymentId, setOldEmploymentId] = useState("");
  const [oldDepartmentId, setOldDepartmentId] = useState("");
  const [oldSectionId, setOldSectionId] = useState("");
  const [oldClassificationId, setOldClassificationId] = useState("");
  const [oldPayTypeId, setOldPayTypeId] = useState("");
  const [oldShiftScheduleId, setOldShiftScheduleId] = useState("");
  const [oldPositionId, setOldPositionId] = useState("");
  const [oldSalaryType, setOldSalaryType] = useState("");
  const [oldSickLeave, setOldSickLeave] = useState("");
  const [oldVacationLeave, setOldVacationLeave] = useState("");
  const [oldServiceIncentiveLeave, setOldServiceIncentiveLeave] = useState("");
  const [oldEmployeeStatus, setOldEmployeeStatus] = useState("");
  const [oldJobTitleId, setOldJobTitleId] = useState("");
  const [oldEmployeeGroup1Id, setOldEmployeeGroup1Id] = useState("");
  const [oldEmployeeGroup2Id, setOldEmployeeGroup2Id] = useState("");

  // Accounts
  const [oldSss, setOldsss] = useState("");
  const [oldTin, setOldTin] = useState("");
  const [oldPassport, setOldPassport] = useState("");
  const [oldPhilhealth, setOldPhilhealth] = useState("");
  const [oldPagibig, setOldPagibig] = useState("");

  // Education
  const [oldEmployeeEducationAttainments, setOldEmployeeEducationAttainments] = useState([]);

  // Dependents
  const [oldEmployeeDependents, setOldEmployeeDependents] = useState([]);

  // Emergency Contacts
  const [oldEmployeeEmergencyContacts, setOldEmployeeEmergencyContacts] = useState([]);

  // Family
  const [oldEmployeeFamilyData, setOldEmployeeFamilyData] = useState([]);

  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
      if (showRequestMessage) {
          const timeoutId = setTimeout(() => {
              setShowRequestMessage(false);
          }, 5000);

          return () => clearTimeout(timeoutId);
      }
      
  }, [showRequestMessage]);
  function GenerateMessage({form, message, isSuccess}){
      return (
          <>
              <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                  {form && (
                  <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                      <div className='column'>
                          {isSuccess ?
                              <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                  <CheckCircleIcon/>
                                  <span >{"SUCCESS MESSAGE"}</span>
                              </div>
                              :
                              <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                  <ErrorIcon/>
                                  <span>{"ERROR MESSAGE"}</span>
                              </div>
                          }
                          <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                      </div>
                  </div>
              )}
              </div>
          </>
      );
  }
  //Request Messages -end

  const apiUrl =  domain + "/api/Employee";

  const handleUpdate = async (event) => {
    event.preventDefault();

    setLoading(true);

    if (!employeeId
      || !lastName
      || !firstName
      || !companyId
      || !locationId
      || !employmentId
      || !departmentId
      || !sectionId
      || !classificationId
      || !payTypeId
      || !shiftScheduleId
      || !positionId
    ) {
        setLoading(false);
        setShowRequestMessage(true);
        setIsSuccess(false);
        setRequestMessage("Please fill up all the required fields. Check Personal and Information Tab.");
        return; // Exit early if fields are empty
    }

    const toBase64 = (file) => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });

    let base64String = "";
    let photoToBeSave = "";

    if(selectedFile){
      base64String = await toBase64(selectedFile);
      photoToBeSave = base64String.split(',')[1];
    }

    let base64StringSignature = "";
    let photoToBeSaveSignature = "";

    if(signature.length > 0){
        base64StringSignature = await toBase64(signature[0]);
        photoToBeSaveSignature = base64StringSignature.split(',')[1];
    }

    const data = {
      id: viewedData.id,
      employeeId: employeeId,
      lastName: lastName,
      firstName: firstName,
      middleName: middleName,
      extensionName: extensionName,
      fullName: lastName + ", " + firstName ,
      nickName: nickName,
      age: age? age : 0,
      dateOfBirth: dateOfBirth? dateOfBirth : null,
      placeOfBirth: placeOfBirth,
      civilStatus: civilStatus,
      bloodType: bloodType,
      height: height,
      weight: weight,
      citizenship: citizenship,
      religion: religion,
      gender: gender,
      mobileNumber: mobileNumber,
      emailAddress: emailAddress,
      blkLot: blkLot,
      street: street,
      barangay: barangay,
      city: city,
      postalCode: postalCode,
      yearsOfStay: yearsOfStay? yearsOfStay : 0,
      photo: selectedFile ? photoToBeSave : "",
      signature: signature ? photoToBeSaveSignature : "",
      deviceNumber: deviceNumber,
      employeeInformation: {
        employeePersonalInformationId: viewedData.id,
        locationId: locationId ? locationId : null,
        dateEmployed: dateEmployed ? dateEmployed : null,
        dateRegular: dateRegular ? dateRegular : null,
        dateProbationary: dateProbationary ? dateProbationary : null,
        dateProjectBase: dateProjectBase ? dateProjectBase : null,
        dateContractual: dateContractual ? dateContractual : null,
        dateResigned: dateResigned ? dateResigned : null,
        employmentId: employmentId ? employmentId : null,
        departmentId: departmentId ? departmentId : null,
        sectionId: sectionId ? sectionId : null,
        classificationId: classificationId ? classificationId : null,
        payTypeId: payTypeId ? payTypeId : null,
        shiftScheduleId: shiftScheduleId ? shiftScheduleId : null,
        positionId: positionId ? positionId : null,
        companyId: companyId ? companyId : null,
        salaryType: salaryType,
        jobTitleId: jobTitleId ? jobTitleId : null,
        employeeGroup1Id: employeeGroup1Id ? employeeGroup1Id : null,
        employeeGroup2Id: employeeGroup2Id ? employeeGroup2Id : null,
        plantilyaId: plantilyaId ? plantilyaId : null,
        costCenterId: costCenterId ? costCenterId : null,
        clientId: clientId ? clientId : null,
      },
      employeeMobileInformation: {
        hasMobileRegisterFeature: hasMobileRegisterFeature ? true : false,
        hasMobileInAndOut: hasMobileInAndOut ? true : false,
      },
      employeeReportTo: {
        employeePersonalInformationId: viewedData.id,
        reportToId: null
      },
      employeeAccountInformation: {
        employeePersonalInformationId: viewedData.id,
        sss: sss,
        tin: tin,
        passport: passport,
        philhealth: philhealth,
        pagibig: pagibig,
      },
      employeeEducationAttainments: employeeEducationAttainments,
      employeeDependents: employeeDependents,
      employeeFamilyData: employeeFamilyData,
      employeeEmergencyContacts: employeeEmergencyContacts,
      employeeLeave: {
        employeePersonalInformationId: viewedData.id,
        totalVacation: vacationLeave,
        totalSick: sickLeave,
        totalServiceIncentive: serviceIncentiveLeave,
        totalSoloParent: soloParentLeave,
        sickRemaining: sickRemaining,
        vacationRemaining: vacationRemaining,
        serviceIncentiveRemaining: serviceIncentiveRemaining,
        soloParentRemaining: soloParentRemaining,
      },
      employeeStatuses: {
        employeePersonalInformationId: viewedData.id,
        status: employeeStatus,
      },
      employeeRestDays: employeeRestDays
    };

    console.log('Final bulkData:', JSON.stringify(data, null, 2));

    try {
        
        await axios.put(apiUrl + `/${viewedData.id}`, data, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        
        logDifferences();
        await fetchData();

        setShowRequestMessage(true);
        setIsSuccess(true);
        setShowSuccess(true);
        console.log('Data updated successfully');
        setViewedData(data);
        setEmployeeId(data.employeeId);
        setLastName(data.lastName);
        setFirstName(data.firstName);
        setMiddleName(data.middleName);
        setExtensionName(data.extensionName);
        setNickName(data.nickName);
        setAge(data.age);
        setDateOfBirth(data.dateOfBirth);
        setPlaceOfBirth(data.placeOfBirth);
        setCivilStatus(data.civilStatus);
        setBloodType(data.bloodType);
        setHeight(data.height);
        setWeight(data.weight);
        setCitizenship(data.citizenship);
        setReligion(data.religion);
        setGender(data.gender);
        setMobileNumber(data.mobileNumber);
        setEmailAddress(data.emailAddress);
        setDeviceNumber(data.deviceNumber);
        setCompanyId(data.employeeInformation.companyId);
        setBlkLot(data.blkLot);
        setStreet(data.street);
        setBarangay(data.barangay);
        setCity(data.city);
        setPostalCode(data.postalCode);
        setYearsOfStay(data.yearsOfStay);

        if(data.photo){
          const binaryData = atob(data.photo);
  
          // Convert the binary data to a Uint8Array
          const arrayBuffer = new ArrayBuffer(binaryData.length);
          const uint8Array = new Uint8Array(arrayBuffer);
          for (let i = 0; i < binaryData.length; i++) {
              uint8Array[i] = binaryData.charCodeAt(i);
          }
  
          const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data
  
          const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type
  
          setEmployeePhoto(file);
          setSelectedFile(file);
        }

        let filesToBeSet = [];
        if(data.signature){
          const binaryData = atob(data.signature);
  
          // Convert the binary data to a Uint8Array
          const arrayBuffer = new ArrayBuffer(binaryData.length);
          const uint8Array = new Uint8Array(arrayBuffer);
          for (let i = 0; i < binaryData.length; i++) {
              uint8Array[i] = binaryData.charCodeAt(i);
          }
  
          const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data
  
          const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type
        
          filesToBeSet.push(file);
        }
  
        setSignature(filesToBeSet);

        setLocationId(data.employeeInformation.locationId);
        setDateEmployed(data.employeeInformation.dateEmployed);
        setDateRegular(data.employeeInformation.dateRegular);
        setDateProbationary(data.employeeInformation.dateProbationary);
        setDateProjectBase(data.employeeInformation.dateProjectBase);
        setDateContractual(data.employeeInformation.dateContractual);
        setDateResigned(data.employeeInformation.dateResigned);
        setEmploymentId(data.employeeInformation.employmentId);
        setDepartmentId(data.employeeInformation.departmentId);
        setSectionId(data.employeeInformation.sectionId);
        setClassificationId(data.employeeInformation.classificationId);
        setPayTypeId(data.employeeInformation.payTypeId);
        setShiftScheduleId(data.employeeInformation.shiftScheduleId);
        setPositionId(data.employeeInformation.positionId);
        setSalaryType(data.employeeInformation.salaryType);
        setJobTitleId(data.employeeInformation.jobTitleId);
        setEmployeeGroup1Id(data.employeeInformation.employeeGroup1Id);
        setEmployeeGroup2Id(data.employeeInformation.employeeGroup2Id);
        setPlantilyaId(data.employeeInformation.plantilyaId);
        setCostCenterId(data.employeeInformation.costCenterId);
        setClientId(data.employeeInformation.clientId);
        setHasMobileRegisterFeature(data.employeeMobileInformation?.hasMobileRegisterFeature ?? false);
        setHasMobileInAndOut(data.employeeMobileInformation?.hasMobileInAndOut ?? false);
        /* setVacationLeave(data.);
        setSickLeave("");
        setServiceIncentiveLeave("");
        setEmployeeStatus(""); */
        setsss(data.employeeAccountInformation.sss);
        setTin(data.employeeAccountInformation.tin);
        setPassport(data.employeeAccountInformation.passport);
        setPhilhealth(data.employeeAccountInformation.philhealth);
        setPagibig(data.employeeAccountInformation.pagibig);

        setVacationLeave((data.employeeLeave && data.employeeLeave.totalVacation) ? data.employeeLeave.totalVacation : 0)
        setSickLeave((data.employeeLeave && data.employeeLeave.totalSick) ? data.employeeLeave.totalSick : 0)
        setServiceIncentiveLeave((data.employeeLeave && data.employeeLeave.totalServiceIncentive) ? data.employeeLeave.totalServiceIncentive : 0)
        setSoloParentLeave((data.employeeLeave && data.employeeLeave.totalSoloParent) ? data.employeeLeave.totalSoloParent : 0)
        setVacationRemaining((data.employeeLeave && data.employeeLeave.vacationRemaining) ? data.employeeLeave.vacationRemaining : 0)
        setSickRemaining((data.employeeLeave && data.employeeLeave.sickRemaining) ? data.employeeLeave.sickRemaining : 0)
        setServiceIncentiveRemaining((data.employeeLeave && data.employeeLeave.setVacationRemaining) ? data.employeeLeave.setVacationRemaining : 0)
        setSoloParentRemaining((data.employeeLeave && data.employeeLeave.soloParentRemaining) ? data.employeeLeave.soloParentRemaining : 0)
        setEmployeeStatus((data.employeeStatuses && data.employeeStatuses.status) ? data.employeeStatuses.status : "")

        setEmployeeEducationAttainments(data.employeeEducationAttainments);
        setEmployeeDependents(data.employeeDependents);
        setEmployeeEmergencyContacts(data.employeeEmergencyContacts);
        setEmployeeFamilyData(data.employeeFamilyData);
        setIsEditMode(false);
    } catch (error) {
        setLoading(false);
        console.error('There was a problem updating data:', error);
        setShowRequestMessage(true);
        setIsSuccess(false);
        const errorMessage = JSON.parse(error.response.request.responseText).message;
        setRequestMessage(errorMessage);
    } finally {
      setLoading(false);
    }
  };
  const handleClose = () => {
    onClose();
    setIsOpenOnce(false);
    setSelectedTab(0);
    setIsFirstPage(true);
    setIsLastPage(false);
    setIsEditMode(false);
    setEmployeeId("");
    setLastName("");
    setFirstName("");
    setMiddleName("");
    setExtensionName("");
    setNickName("");
    setAge("");
    setDateOfBirth("");
    setPlaceOfBirth("");
    setCivilStatus("");
    setBloodType("");
    setHeight("");
    setWeight("");
    setCitizenship("");
    setReligion("");
    setGender("");
    setMobileNumber("");
    setEmailAddress("");
    setDeviceNumber("");
    setCompanyId("");
    setBlkLot("");
    setStreet("");
    setBarangay("");
    setCity("");
    setPostalCode("");
    setYearsOfStay("");
    setSelectedFile("");
    setSignature([]);
    setLocationId("");
    setDateEmployed("");
    setDateRegular("");
    setDateProbationary("");
    setDateProjectBase("");
    setDateContractual("");
    setDateResigned("");
    setEmploymentId("");
    setDepartmentId("");
    setSectionId("");
    setClassificationId("");
    setPayTypeId("");
    setShiftScheduleId("");
    setPositionId("");
    setSalaryType("");
    setJobTitleId("");
    setEmployeeGroup1Id("");
    setEmployeeGroup2Id("");
    setPlantilyaId("");
    setCostCenterId("");
    setClientId("");
    setHasMobileRegisterFeature(false);
    setHasMobileInAndOut(false);
    setVacationLeave("")
    setSickLeave("")
    setServiceIncentiveLeave("")
    setSoloParentLeave("")
    setVacationRemaining("")
    setSickRemaining("")
    setServiceIncentiveRemaining("")
    setSoloParentRemaining("")
    setEmployeeStatus("")
    setsss("");
    setTin("");
    setPassport("");
    setPhilhealth("");
    setPagibig("");
    setEmployeeEducationAttainments([]);
    setEmployeeDependents([]);
    setEmployeeEmergencyContacts([]);
    setEmployeeFamilyData([]);
  };

  useEffect(() => {
    if(isOpen && !isOpenOnce){
      setIsOpenOnce(true);
      setEmployeeId(viewedData.employeeId);
      setLastName(viewedData.lastName);
      setFirstName(viewedData.firstName);
      setMiddleName(viewedData.middleName);
      setExtensionName(viewedData.extensionName);
      setNickName(viewedData.nickName);
      setAge(viewedData.age);
      setDateOfBirth(viewedData.dateOfBirth);
      setPlaceOfBirth(viewedData.placeOfBirth);
      setCivilStatus(viewedData.civilStatus);
      setBloodType(viewedData.bloodType);
      setHeight(viewedData.height);
      setWeight(viewedData.weight);
      setCitizenship(viewedData.citizenship);
      setReligion(viewedData.religion);
      setGender(viewedData.gender);
      setMobileNumber(viewedData.mobileNumber);
      setEmailAddress(viewedData.emailAddress);
      setDeviceNumber(viewedData.deviceNumber);
      setBlkLot(viewedData.blkLot);
      setStreet(viewedData.street);
      setBarangay(viewedData.barangay);
      setCity(viewedData.city);
      setPostalCode(viewedData.postalCode);
      setYearsOfStay(viewedData.yearsOfStay);

      if(viewedData.photo){
        const binaryData = atob(viewedData.photo);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
            uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data

        const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type

        setSelectedFile(file);
      }

      let filesToBeSet = [];
      if(viewedData.signature){
        const binaryData = atob(viewedData.signature);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
            uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data

        const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type

        filesToBeSet.push(file);
      }

      setSignature(filesToBeSet);

      if(viewedData.employeeInformation){
        setCompanyId(viewedData.employeeInformation.companyId);
        setLocationId(viewedData.employeeInformation.locationId);
        setDateEmployed(viewedData.employeeInformation.dateEmployed);
        setDateRegular(viewedData.employeeInformation.dateRegular);
        setDateProbationary(viewedData.employeeInformation.dateProbationary);
        setDateProjectBase(viewedData.employeeInformation.dateProjectBase);
        setDateContractual(viewedData.employeeInformation.dateContractual);
        setDateResigned(viewedData.employeeInformation.dateResigned);
        setEmploymentId(viewedData.employeeInformation.employmentId);
        setDepartmentId(viewedData.employeeInformation.departmentId);
        setSectionId(viewedData.employeeInformation.sectionId);
        setClassificationId(viewedData.employeeInformation.classificationId);
        setPayTypeId(viewedData.employeeInformation.payTypeId);
        setShiftScheduleId(viewedData.employeeInformation.shiftScheduleId);
        setPositionId(viewedData.employeeInformation.positionId);
        setSalaryType(viewedData.employeeInformation.salaryType);
        setJobTitleId(viewedData.employeeInformation.jobTitleId);
        setEmployeeGroup1Id(viewedData.employeeInformation.employeeGroup1Id);
        setEmployeeGroup2Id(viewedData.employeeInformation.employeeGroup2Id);
        setPlantilyaId(viewedData.employeeInformation.plantilyaId);
        setCostCenterId(viewedData.employeeInformation.costCenterId);
        setClientId(viewedData.employeeInformation.clientId);
        setHasMobileRegisterFeature(viewedData?.employeeMobileInformation?.hasMobileRegisterFeature ?? false);
        setHasMobileInAndOut(viewedData?.employeeMobileInformation?.hasMobileInAndOut ?? false);
      } else {
        setCompanyId("");
        setLocationId("");
        setDateEmployed("");
        setDateRegular("");
        setDateProbationary("");
        setDateProjectBase("");
        setDateContractual("");
        setEmploymentId("");
        setDepartmentId("");
        setSectionId("");
        setClassificationId("");
        setPayTypeId("");
        setShiftScheduleId("");
        setPositionId("");
        setSalaryType("");
        setJobTitleId("");
        setEmployeeGroup1Id("");
        setEmployeeGroup2Id("");
        setPlantilyaId("");
        setCostCenterId("");
        setClientId("");
        setHasMobileRegisterFeature(false);
        setHasMobileInAndOut(false);
      }

      if(viewedData.employeeLeave){
        setSickLeave(viewedData.employeeLeave.totalSick ? viewedData.employeeLeave.totalSick : 0);
        setVacationLeave(viewedData.employeeLeave.totalVacation ? viewedData.employeeLeave.totalVacation : 0);
        setServiceIncentiveLeave(viewedData.employeeLeave.totalServiceIncentive ? viewedData.employeeLeave.totalServiceIncentive : 0);
        setSoloParentLeave(viewedData.employeeLeave.totalSoloParent ? viewedData.employeeLeave.totalSoloParent : 0);

        setSickRemaining(viewedData.employeeLeave.sickRemaining ? viewedData.employeeLeave.sickRemaining : 0);
        setVacationRemaining(viewedData.employeeLeave.vacationRemaining ? viewedData.employeeLeave.vacationRemaining : 0);
        setServiceIncentiveRemaining(viewedData.employeeLeave.serviceIncentiveRemaining ? viewedData.employeeLeave.serviceIncentiveRemaining : 0);
        setSoloParentRemaining(viewedData.employeeLeave.soloParentRemaining ? viewedData.employeeLeave.soloParentRemaining : 0);
      } else {
        setSickLeave(0);
        setVacationLeave(0);
        setServiceIncentiveLeave(0);
        setSoloParentLeave(0);

        setSickRemaining(0);
        setVacationRemaining(0);
        setServiceIncentiveRemaining(0);
        setSoloParentRemaining(0);
      }

      if(viewedData.employeeStatuses){
        setEmployeeStatus(viewedData.employeeStatuses.status ? viewedData.employeeStatuses.status : "");
      } else {
        setEmployeeStatus("");
      }

      setsss(viewedData.employeeAccountInformation ? viewedData.employeeAccountInformation.sss : null);
      setTin(viewedData.employeeAccountInformation ? viewedData.employeeAccountInformation.tin : null);
      setPassport(viewedData.employeeAccountInformation ? viewedData.employeeAccountInformation.passport : null);
      setPhilhealth(viewedData.employeeAccountInformation ? viewedData.employeeAccountInformation.philhealth : null);
      setPagibig(viewedData.employeeAccountInformation ? viewedData.employeeAccountInformation.pagibig : null);
      setEmployeeEducationAttainments(viewedData.employeeEducationAttainments);
      setEmployeeDependents(viewedData.employeeDependents);
      setEmployeeEmergencyContacts(viewedData.employeeEmergencyContacts);
      setEmployeeFamilyData(viewedData.employeeFamilyData);
      setEmployeeRestDays(viewedData.employeeRestDays);
    }
  }, [isOpen, viewedData, isOpenOnce]);

  useEffect(() => {
    if(!isInit) {
      setIsInit(true);
      setOldEmployeeId(viewedData.employeeId);
      setOldLastName(viewedData.lastName);
      setOldFirstName(viewedData.firstName);
      setOldMiddleName(viewedData.middleName);
      setOldExtensionName(viewedData.extensionName);
      setOldNickName(viewedData.nickName);
      setOldAge(viewedData.age);
      setOldDateOfBirth(viewedData.dateOfBirth);
      setOldPlaceOfBirth(viewedData.placeOfBirth);
      setOldCivilStatus(viewedData.civilStatus);
      setOldBloodType(viewedData.bloodType);
      setOldHeight(viewedData.height);
      setOldWeight(viewedData.weight);
      setOldCitizenship(viewedData.citizenship);
      setOldReligion(viewedData.religion);
      setOldGender(viewedData.gender);
      setOldMobileNumber(viewedData.mobileNumber);
      setOldEmailAddress(viewedData.emailAddress);
      setOldDeviceNumber(viewedData.deviceNumber);
      setOldBlkLot(viewedData.blkLot);
      setOldStreet(viewedData.street);
      setOldBarangay(viewedData.barangay);
      setOldCity(viewedData.city);
      setOldPostalCode(viewedData.postalCode);
      setOldYearsOfStay(viewedData.yearsOfStay);

      if(viewedData.photo){
        const binaryData = atob(viewedData.photo);

        // Convert the binary data to a Uint8Array
        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryData.length; i++) {
            uint8Array[i] = binaryData.charCodeAt(i);
        }

        const blob = new Blob([uint8Array], { type: 'image/jpeg' }); // Adjust the MIME type as per your data

        const file = new File([blob], 'filename.jpg', { type: 'image/jpeg' }); // Provide a filename and MIME type

        setOldSelectedFile(file);
      }

      if(viewedData.employeeInformation){
        setOldCompanyId(viewedData.employeeInformation.companyId);
        setOldLocationId(viewedData.employeeInformation.locationId);
        setOldDateEmployed(viewedData.employeeInformation.dateEmployed);
        setOldDateRegular(viewedData.employeeInformation.dateRegular);
        setOldDateProbationary(viewedData.employeeInformation.dateProbationary);
        setOldDateProjectBase(viewedData.employeeInformation.dateProjectBase);
        setOldDateContractual(viewedData.employeeInformation.dateContractual);
        setOldEmploymentId(viewedData.employeeInformation.employmentId);
        setOldDepartmentId(viewedData.employeeInformation.departmentId);
        setOldSectionId(viewedData.employeeInformation.sectionId);
        setOldClassificationId(viewedData.employeeInformation.classificationId);
        setOldPayTypeId(viewedData.employeeInformation.payTypeId);
        setOldShiftScheduleId(viewedData.employeeInformation.shiftScheduleId);
        setOldPositionId(viewedData.employeeInformation.positionId);
        setOldSalaryType(viewedData.employeeInformation.salaryType);
        setOldJobTitleId(viewedData.employeeInformation.jobTitleId);
        setOldEmployeeGroup1Id(viewedData.employeeInformation.employeeGroup1Id);
        setOldEmployeeGroup2Id(viewedData.employeeInformation.employeeGroup2Id);
      } else {
        setOldCompanyId("");
        setOldLocationId("");
        setOldDateEmployed("");
        setOldDateRegular("");
        setOldDateProbationary("");
        setOldDateProjectBase("");
        setOldDateContractual("");
        setOldEmploymentId("");
        setOldDepartmentId("");
        setOldSectionId("");
        setOldClassificationId("");
        setOldPayTypeId("");
        setOldShiftScheduleId("");
        setOldPositionId("");
        setOldSalaryType("");
        setOldJobTitleId("");
        setOldEmployeeGroup1Id("");
        setOldEmployeeGroup2Id("");
      }

      if(viewedData.employeeLeave){
        setOldSickLeave(viewedData.employeeLeave.totalSick ? viewedData.employeeLeave.totalSick : 0);
        setOldVacationLeave(viewedData.employeeLeave.totalVacation ? viewedData.employeeLeave.totalVacation : 0);
        setOldServiceIncentiveLeave(viewedData.employeeLeave.totalServiceIncentive ? viewedData.employeeLeave.totalServiceIncentive : 0);
      } else {
        setOldSickLeave(0);
        setOldVacationLeave(0);
        setOldServiceIncentiveLeave(0);
      }

      if(viewedData.employeeStatuses){
        setOldEmployeeStatus(viewedData.employeeStatuses.status ? viewedData.employeeStatuses.status : "");
      } else {
        setOldEmployeeStatus("");
      }

      setOldsss(viewedData.employeeAccountInformation ? viewedData.employeeAccountInformation.sss : null);
      setOldTin(viewedData.employeeAccountInformation ? viewedData.employeeAccountInformation.tin : null);
      setOldPassport(viewedData.employeeAccountInformation ? viewedData.employeeAccountInformation.passport : null);
      setOldPhilhealth(viewedData.employeeAccountInformation ? viewedData.employeeAccountInformation.philhealth : null);
      setOldPagibig(viewedData.employeeAccountInformation ? viewedData.employeeAccountInformation.pagibig : null);
      setOldEmployeeEducationAttainments(viewedData.employeeEducationAttainments);
      setOldEmployeeDependents(viewedData.employeeDependents);
      setOldEmployeeEmergencyContacts(viewedData.employeeEmergencyContacts);
      setOldEmployeeFamilyData(viewedData.employeeFamilyData);
    }
  }, [isInit, viewedData]);

  useEffect(() => {
    if (selectedTab > 0) {
      setIsFirstPage(false);
    } else {
      setIsFirstPage(true);
    }

    if (selectedTab === 8) {
      setIsLastPage(true);
    } else {
      setIsLastPage(false);
    }
  }, [selectedTab]);

  useEffect(() => {
    if (showSuccess) {
      const timeoutId = setTimeout(() => {
          setShowSuccess(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [showSuccess]); // This useEffect will run whenever selectedTab changes

  const setButtonId= (name) => {
    if(name === "previous-button"){
      if(isFirstPage){
        return "previous-button"
      } else {
        return "active-previous-button"
      }
    } else if(name === "next-button"){
      if(isLastPage){
        return "next-button"
      } else {
        return "active-next-button"
      }
    }
  }

  const logDifferences = async () => {
    const fieldsToCompare = [
      { oldValue: oldEmployeeId, newValue: employeeId, field: `${employeeId} Employee ID` },
      { oldValue: oldSelectedFile, newValue: selectedFile, field: `${employeeId} Photo` },
      { oldValue: oldLastName, newValue: lastName, field: `${employeeId} Last Name` },
      { oldValue: oldFirstName, newValue: firstName, field: `${employeeId} First Name` },
      { oldValue: oldMiddleName, newValue: middleName, field: `${employeeId} Middle Name` },
      { oldValue: oldExtensionName, newValue: extensionName, field: `${employeeId} Extension Name` },
      { oldValue: oldNickName, newValue: nickName, field: `${employeeId} Nick Name` },
      { oldValue: oldAge, newValue: age, field: `${employeeId} Age` },
      { oldValue: oldDateOfBirth, newValue: dateOfBirth, field: `${employeeId} Date of Birth` },
      { oldValue: oldPlaceOfBirth, newValue: placeOfBirth, field: `${employeeId} Place of Birth` },
      { oldValue: oldCivilStatus, newValue: civilStatus, field: `${employeeId} Civil Status` },
      { oldValue: oldBloodType, newValue: bloodType, field: `${employeeId} Blood Type` },
      { oldValue: oldHeight, newValue: height, field: `${employeeId} Height` },
      { oldValue: oldWeight, newValue: weight, field: `${employeeId} Weight` },
      { oldValue: oldCitizenship, newValue: citizenship, field: `${employeeId} Citizenship` },
      { oldValue: oldReligion, newValue: religion, field: `${employeeId} Religion` },
      { oldValue: oldGender, newValue: gender, field: `${employeeId} Gender` },
      { oldValue: oldMobileNumber, newValue: mobileNumber, field: `${employeeId} Mobile Number` },
      { oldValue: oldEmailAddress, newValue: emailAddress, field: `${employeeId} Email Address` },
      { oldValue: oldDeviceNumber, newValue: deviceNumber, field: `${employeeId} Device Number` },
      { oldValue: oldCompanyId, newValue: companyId, field: `${employeeId} Company ID` },
      { oldValue: oldBlkLot, newValue: blkLot, field: `${employeeId} Blk Lot` },
      { oldValue: oldStreet, newValue: street, field: `${employeeId} Street` },
      { oldValue: oldBarangay, newValue: barangay, field: `${employeeId} Barangay` },
      { oldValue: oldCity, newValue: city, field: `${employeeId} City` },
      { oldValue: oldPostalCode, newValue: postalCode, field: `${employeeId} Postal Code` },
      { oldValue: oldYearsOfStay, newValue: yearsOfStay, field: `${employeeId} Years of Stay` },
      { oldValue: oldLocationId, newValue: locationId, field: `${employeeId} Location ID` },
      { oldValue: oldDateEmployed, newValue: dateEmployed, field: `${employeeId} Date Employed` },
      { oldValue: oldDateRegular, newValue: dateRegular, field: `${employeeId} Date Regular` },
      { oldValue: oldDateProbationary, newValue: dateProbationary, field: `${employeeId} Date Probationary` },
      { oldValue: oldDateProjectBase, newValue: dateProjectBase, field: `${employeeId} Date Project Base` },
      { oldValue: oldDateContractual, newValue: dateContractual, field: `${employeeId} Date Contractual` },
      { oldValue: oldEmploymentId, newValue: employmentId, field: `${employeeId} Employment ID` },
      { oldValue: oldDepartmentId, newValue: departmentId, field: `${employeeId} Department ID` },
      { oldValue: oldSectionId, newValue: sectionId, field: `${employeeId} Section ID` },
      { oldValue: oldClassificationId, newValue: classificationId, field: `${employeeId} Classification ID` },
      { oldValue: oldPayTypeId, newValue: payTypeId, field: `${employeeId} Pay Type ID` },
      { oldValue: oldShiftScheduleId, newValue: shiftScheduleId, field: `${employeeId} Shift Schedule ID` },
      { oldValue: oldPositionId, newValue: positionId, field: `${employeeId} Position ID` },
      { oldValue: oldSalaryType, newValue: salaryType, field: `${employeeId} Salary Type` },
      { oldValue: oldJobTitleId, newValue: jobTitleId, field: `${employeeId} Job Title` },
      { oldValue: oldEmployeeGroup1Id, newValue: employeeGroup1Id, field: `${employeeId} Employee Group 1` },
      { oldValue: oldEmployeeGroup2Id, newValue: employeeGroup2Id, field: `${employeeId} Employee Group 2` },
      { oldValue: oldSickLeave, newValue: sickLeave, field: `${employeeId} Sick Leave` },
      { oldValue: oldVacationLeave, newValue: vacationLeave, field: `${employeeId} Vacation Leave` },
      { oldValue: oldServiceIncentiveLeave, newValue: serviceIncentiveLeave, field: `${employeeId} Service Incentive Leave` },
      { oldValue: oldEmployeeStatus, newValue: employeeStatus, field: `${employeeId} Employee Status` },
      { oldValue: oldSss, newValue: sss, field: `${employeeId} SSS` },
      { oldValue: oldTin, newValue: tin, field: `${employeeId} TIN` },
      { oldValue: oldPassport, newValue: passport, field: `${employeeId} Passport` },
      { oldValue: oldPhilhealth, newValue: philhealth, field: `${employeeId} PhilHealth` },
      { oldValue: oldPagibig, newValue: pagibig, field: `${employeeId} PagIbig` },
      { oldValue: oldEmployeeEducationAttainments, newValue: employeeEducationAttainments, field: `${employeeId} Employee Education` },
      { oldValue: oldEmployeeDependents, newValue: employeeDependents, field: `${employeeId} Employee Dependents` },
      { oldValue: oldEmployeeEmergencyContacts, newValue: employeeEmergencyContacts, field: `${employeeId} Emergency Contacts` },
      { oldValue: oldEmployeeFamilyData, newValue: employeeFamilyData, field: `${employeeId} Family Data` },
    ];
  
    for (const { oldValue, newValue, field } of fieldsToCompare) {
      const difference = getDifference(oldValue, newValue, field);
      if (difference.isDifferent) {
        await SetAuditTrail({
          setupArea: `Employee List`,
          actionTaken: `update`,
          field: field, // Set the correct field name
          newValue: difference.newValue ? `${difference.newValue}` : `-`, // Set the actual new value or fallback
          oldValue: difference.oldValue ? `${difference.oldValue}` : `-`, // Set the actual old value or fallback
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
    }
  };
  const getDifference = (oldValue, newValue, field) => {
    let difference = {
        isDifferent: false,
        field: "",
        oldValue: "",
        newValue: ""
    };

    // Check if either oldValue or newValue is an object
    const isObject = (value) => typeof value === 'object' && value !== null;

    const formatValue = (value) => {
        if (isObject(value)) {
            return "-"; // If value is an object, return "-"
        }
        return value; // Return the value itself if it's not an object
    };

    if (oldValue !== newValue) {
        difference = {
            isDifferent: true,
            field: field,
            oldValue: formatValue(oldValue),
            newValue: formatValue(newValue)
        };
    }

    return difference;
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
          {isOpen && (
          <div className="modal view-employee">
            <div className="popUp-header view-employee-header row">
                <div className='popUp-title'><h3 style={{color:"#668fca"}}>View Employee</h3></div>
                <div className='popUp-close'><CloseIcon onClick={()=>handleClose()}/></div>
            </div>
            <div>
              <div  className="educations-tab-top" 
                    style={{display:"flex", 
                    justifyContent:"start", 
                    padding:"0 20px",
                    visibility: isEditMode? "hidden" : "visible"
                    }}>
                {CreateButton("addEmployee-education-add", "add row", ()=>setIsEditMode(true), "EDIT INFO", "")}
              </div>
              <div className="employeesTab-body">
                <div className='employeesTab-tab view-emp'>
                  <div style={{    border: "1px solid #00000026", borderRadius: "5px"}}>
                    <Tabs id="employees-tabs-element" selectedIndex={selectedTab} onSelect={index => setSelectedTab(index)}>
                      <TabList>
                          <Tab><b>PERSONAL</b></Tab>
                          <Tab><b>ADDRESS</b></Tab>
                          <Tab><b>INFORMATION</b></Tab>
                          <Tab><b>ACCOUNTS</b></Tab>
                          <Tab><b>EDUCATIONS</b></Tab>
                          <Tab><b>DEPENDENTS</b></Tab>
                          <Tab><b>EMERGENCY</b></Tab>
                          <Tab><b>FAMILY</b></Tab>
                          <Tab><b>BENEFITS</b></Tab>
                          <Tab><b>REQUIREMENTS</b></Tab>
                          <Tab><b>GENERATE ID</b></Tab>
                      </TabList>
                      <div className="employeesTab-tabPanel" style={{overflow: "auto"}}>
                          <TabPanel>
                            <PersonalTab employeeId={employeeId} 
                                        selectedFile={selectedFile} 
                                        setSelectedFile={setSelectedFile}
                                        lastName={lastName}
                                        firstName={firstName}
                                        middleName={middleName}
                                        extensionName={extensionName}
                                        nickName={nickName}
                                        age={age}
                                        dateOfBirth={dateOfBirth}
                                        placeOfBirth={placeOfBirth}
                                        civilStatus={civilStatus}
                                        bloodType={bloodType}
                                        height={height}
                                        weight={weight}
                                        citizenship={citizenship}
                                        religion={religion}
                                        gender={gender}
                                        mobileNumber={mobileNumber}
                                        emailAddress={emailAddress}
                                        deviceNumber={deviceNumber}
                                        companyId={companyId}
                                        setEmployeeId={setEmployeeId}
                                        setLastName={setLastName}
                                        setFirstName={setFirstName}
                                        setMiddleName={setMiddleName}
                                        setExtensionName={setExtensionName}
                                        setNickName={setNickName}
                                        setAge={setAge}
                                        setDateOfBirth={setDateOfBirth}
                                        setPlaceOfBirth={setPlaceOfBirth}
                                        setCivilStatus={setCivilStatus}
                                        setBloodType={setBloodType}
                                        setHeight={setHeight}
                                        setWeight={setWeight}
                                        setCitizenship={setCitizenship}
                                        setReligion={setReligion}
                                        setGender={setGender}
                                        setMobileNumber={setMobileNumber}
                                        setEmailAddress={setEmailAddress}
                                        setDeviceNumber={setDeviceNumber}
                                        setCompanyId={setCompanyId}

                                        signature={signature} setSignature={setSignature}

                                        isEditMode={isEditMode}
                            />
                          </TabPanel>
                          
                          <TabPanel>
                            <AddressTab blkLot={blkLot}
                                        street={street}
                                        barangay={barangay}
                                        city={city}
                                        postalCode={postalCode}
                                        yearsOfStay={yearsOfStay}
                                        setBlkLot={setBlkLot}
                                        setStreet={setStreet}
                                        setBarangay={setBarangay}
                                        setCity={setCity}
                                        setPostalCode={setPostalCode}
                                        setYearsOfStay={setYearsOfStay}
                                        isEditMode={isEditMode}
                            />
                          </TabPanel>

                          <TabPanel>
                            <InformationTab locationId={locationId}
                                            dateEmployed={dateEmployed}
                                            dateRegular={dateRegular}
                                            dateProbationary={dateProbationary}
                                            dateProjectBase={dateProjectBase}
                                            dateContractual={dateContractual}
                                            dateResigned={dateResigned}
                                            employmentId={employmentId}
                                            departmentId={departmentId}
                                            sectionId={sectionId}
                                            classificationId={classificationId}
                                            payTypeId={payTypeId}
                                            shiftScheduleId={shiftScheduleId}
                                            positionId={positionId}
                                            salaryType={salaryType}
                                            setLocationId={setLocationId}
                                            setDateEmployed={setDateEmployed}
                                            setDateRegular={setDateRegular}
                                            setDateProbationary={setDateProbationary}
                                            setDateProjectBase={setDateProjectBase}
                                            setDateContractual={setDateContractual}
                                            setDateResigned={setDateResigned}
                                            setEmploymentId={setEmploymentId}
                                            setDepartmentId={setDepartmentId}
                                            setSectionId={setSectionId}
                                            setClassificationId={setClassificationId}
                                            setPayTypeId={setPayTypeId}
                                            setShiftScheduleId={setShiftScheduleId}
                                            setPositionId={setPositionId}
                                            setSalaryType={setSalaryType}
                                            sickLeave={sickLeave}
                                            setSickLeave={setSickLeave}
                                            vacationLeave={vacationLeave}
                                            setVacationLeave={setVacationLeave}
                                            employeeStatus={employeeStatus}
                                            setEmployeeStatus={setEmployeeStatus}
                                            serviceIncentiveLeave={serviceIncentiveLeave}
                                            setServiceIncentiveLeave={setServiceIncentiveLeave}
                                            soloParentLeave={soloParentLeave} 
                                            setSoloParentLeave={setSoloParentLeave}

                                            sickRemaining={sickRemaining}
                                            setSickRemaining={setSickRemaining}
                                            vacationRemaining={vacationRemaining}
                                            setVacationRemaining={setVacationRemaining}
                                            serviceIncentiveRemaining={serviceIncentiveRemaining}
                                            setServiceIncentiveRemaining={setServiceIncentiveRemaining}
                                            soloParentRemaining={soloParentRemaining} 
                                            setSoloParentRemaining={setSoloParentRemaining}
                                            isEditMode={isEditMode}

                                            jobTitleId={jobTitleId} setJobTitleId={setJobTitleId}
                                            employeeGroup1Id={employeeGroup1Id} setEmployeeGroup1Id={setEmployeeGroup1Id}
                                            employeeGroup2Id={employeeGroup2Id} setEmployeeGroup2Id={setEmployeeGroup2Id}
                                            plantilyaId={plantilyaId}
                                            setPlantilyaId={setPlantilyaId}
                                            costCenterId={costCenterId}
                                            setCostCenterId={setCostCenterId}
                                            clientId={clientId}
                                            setClientId={setClientId}
                                            hasMobileRegisterFeature={hasMobileRegisterFeature}
                                            setHasMobileRegisterFeature={setHasMobileRegisterFeature}
                                            hasMobileInAndOut={hasMobileInAndOut}
                                            setHasMobileInAndOut={setHasMobileInAndOut}

                                            employeeRestDays={employeeRestDays} setEmployeeRestDays={setEmployeeRestDays}
                            />
                          </TabPanel>

                          <TabPanel>
                            <AccountsTab  sss={sss}
                                          tin={tin}
                                          passport={passport}
                                          philhealth={philhealth}
                                          pagibig={pagibig}
                                          setsss={setsss}
                                          setTin={setTin}
                                          setPassport={setPassport}
                                          setPhilhealth={setPhilhealth}
                                          setPagibig={setPagibig}
                                          isEditMode={isEditMode}
                            />
                          </TabPanel>

                          <TabPanel>
                            <EducationsTab  employeeId={employeeId}
                                            employeeEducationAttainments={employeeEducationAttainments}
                                            setEmployeeEducationAttainments={setEmployeeEducationAttainments}
                                            isEditMode={isEditMode}
                            />
                          </TabPanel>

                          <TabPanel>
                            <DependentsTab  employeeId={employeeId}
                                            employeeDependents={employeeDependents} 
                                            setEmployeeDependents={setEmployeeDependents}
                                            isEditMode={isEditMode}
                            />
                          </TabPanel>

                          <TabPanel>
                            <EmergencyTab employeeId={employeeId}
                                          employeeEmergencyContacts={employeeEmergencyContacts}
                                          setEmployeeEmergencyContacts={setEmployeeEmergencyContacts}
                                          isEditMode={isEditMode}
                            />
                          </TabPanel>

                          <TabPanel>
                            <FamilyTab  employeeId={employeeId}
                                        employeeFamilyData={employeeFamilyData}
                                        setEmployeeFamilyData={setEmployeeFamilyData}
                                        isEditMode={isEditMode}
                            />
                          </TabPanel>

                          <TabPanel>
                            <BenefitsTab  
                              viewedData={viewedData}
                              isEditMode={isEditMode}
                            />
                          </TabPanel>

                          <TabPanel>
                            <RequirementsTab  
                              viewedData={viewedData}
                              isEditMode={isEditMode}
                            />
                          </TabPanel>

                          <TabPanel>
                            <GenerateIdTab viewedData={viewedData}/>
                          </TabPanel>
                      </div>
                    </Tabs>
                  </div>
                    <div className="lowerpart">
                      <div style={{display: isEditMode? "flex" : "none", justifyContent:"center", padding:"20px 0"}}>
                        <button className="submit"
                                onClick={(event) => handleUpdate(event)}> SUBMIT
                        </button>
                      </div>
                    </div>
                    <div className="tab-footer">
                      <div className="buttons row" style={{justifyContent:"space-between"}}>
                        <button id={setButtonId("previous-button")} 
                                className="previous row" 
                                onClick={()=>setSelectedTab(Previous(selectedTab))}><NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                        </button>
                        <button id={setButtonId("next-button")} 
                                className="next row" 
                                onClick={()=>setSelectedTab(Next(selectedTab))}> NEXT <NavigateNextIcon style={{marginLeft:"5px"}}/>
                        </button>
                        </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        )}
        </div>
        <GenerateMessage form={showRequestMessage}
              message={isSuccess ? "Request Success!" : requestMessage}
              isSuccess={isSuccess}
      > 
      </GenerateMessage>
      {loading ? (
          <div
              style={{
              position: "fixed",
              top: "0",
              left: "0",
              width: "100vw",
              height: "100vh",
              zIndex: "5000",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              backgroundColor: "#ffffff59",
              }}
          >
              <img src={loadingSpinner} alt="Loading..." />
          </div>
      ) : (
              <></>
          )
      }
    </>
  )
}

function PersonalTab({
  employeeId,
  selectedFile,
  setSelectedFile,
  lastName,
  firstName,
  middleName,
  extensionName,
  nickName,
  age,
  dateOfBirth,
  placeOfBirth,
  civilStatus,
  bloodType,
  height,
  weight,
  citizenship,
  religion,
  gender,
  mobileNumber,
  emailAddress,
  deviceNumber,
  companyId,
  setEmployeeId,
  setLastName,
  setFirstName,
  setMiddleName,
  setExtensionName,
  setNickName,
  setAge,
  setDateOfBirth,
  setPlaceOfBirth,
  setCivilStatus,
  setBloodType,
  setHeight,
  setWeight,
  setCitizenship,
  setReligion,
  setGender,
  setMobileNumber,
  setEmailAddress,
  setDeviceNumber,
  setCompanyId,

  signature, setSignature,

  isEditMode
}){
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    // Check if the selected file is an image
    if (file && file.type.startsWith("image/")) {
      setSelectedFile(file);
    } else {
      // Handle case where non-image file is selected
      alert("Please select an image file.");
    }
  };

  // for upload
  const handleBrowse = (e) => {
    const fileList = Array.from(e.target.files);

    if (fileList.length > 0) {
        if(!fileList[0].type.startsWith("image/")){
            alert("Please select an image file.");
            setSignature("");
            return;
        }
    }

    setSignature(fileList);
  };
  const handleDrop = (e) => {
      e.preventDefault();
      
      const fileList = Array.from(e.dataTransfer.files);
      e.currentTarget.style.backgroundColor = "white";

      if (fileList.length > 0) {
          if(!fileList[0].type.startsWith("image/")){
              alert("Please select an image file.");
              setSignature("");
              return;
          }
      }

      setSignature(fileList);
  };
  const handleDragOver = (e) => {
      e.preventDefault();
      e.currentTarget.style.backgroundColor = "#bdbdbd7d";
  };
  const handleDragOut = (e) => {
      e.preventDefault();
      e.currentTarget.style.backgroundColor = "white";
  };
  const clearFiles = () => {
      // Clear the files state
      setSignature([]);
      // Reset the value of the file input
      document.getElementById('fileInput').value = '';
  };

  return (
    <div className="personal-tab column">
      <div className="major-info row">
        <div className="major-info-left column">
            <label htmlFor="file-input" className='column' style={{
              color: "#808080b5",
              fontSize: "14px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer" // Add cursor pointer for better user interaction
            }}>
              <img src={selectedFile ? URL.createObjectURL(selectedFile) : "images/sample.jpg"} alt=""></img>
              {selectedFile ? selectedFile.name : "Click the placeholder to upload a picture"}
            </label>
            <input
              id="file-input"
              type="file"
              style={{ display: "none" }}
              onChange={handleFileChange}
              disabled={!isEditMode}
            />
        </div>
        <div className="major-info-right column">
          <div className="major-info-right-item info-item-holder row">
            <div className="info-item info-item3 column">
              <div className="info-item-label row" style={{alignItems:"center"}}>Employee Id<span style={{visibility: isEditMode ? "visible" : "hidden", color:"red",fontSize:"10px", marginLeft:"5px"}}>(*required)</span></div>
              <div className="info-item-input">
                <input id="AddEmployee-EmployeeId" placeholder="Employee Id"
                readOnly value={employeeId} onChange={(e) => setEmployeeId(e.target.value)}
                /></div>
            </div>
            <div className="info-item info-item3 column">
              <div className="info-item-label">Device No.</div>
              <div className="info-item-input">
                <input type='number' id="AddEmployee-DeviceNo" placeholder="Device No"
                readOnly={!isEditMode} value={deviceNumber} onChange={(e) => setDeviceNumber(e.target.value)}
                /></div>
            </div>
            <div className="info-item info-item3 column">
              <div className="info-item-label row" style={{alignItems:"center"}}>Company<span style={{visibility: isEditMode ? "visible" : "hidden", color:"red",fontSize:"10px", marginLeft:"5px"}}>(*required)</span></div>
              <div className="info-item-input">{CompanyTypeIdSelect(companyId, setCompanyId, isEditMode)}</div>
            </div>
          </div>
          <div className="major-info-right-item info-item-holder row">
            <div className="info-item info-item3 column">
              <div className="info-item-label row" style={{alignItems:"center"}}>Last Name<span style={{visibility: isEditMode ? "visible" : "hidden", color:"red",fontSize:"10px", marginLeft:"5px"}}>(*required)</span></div>
              <div className="info-item-input">
                <input id="AddEmployee-LastName" placeholder="Last Name"
                readOnly={!isEditMode} value={lastName} onChange={(e) => setLastName(e.target.value)}
                /></div>
            </div>
            <div className="info-item info-item3 column">
              <div className="info-item-label row" style={{alignItems:"center"}}>First Name<span style={{visibility: isEditMode ? "visible" : "hidden", color:"red",fontSize:"10px", marginLeft:"5px"}}>(*required)</span></div>
              <div className="info-item-input">
                <input id="AddEmployee-FirstName" placeholder="First Name"
                readOnly={!isEditMode} value={firstName} onChange={(e) => setFirstName(e.target.value)}
                /></div>
            </div>
            <div className="info-item info-item3 column">
              <div className="info-item-label row" style={{alignItems:"center"}}>Middle Name</div>
              <div className="info-item-input">
                <input id="AddEmployee-MiddleName" placeholder="Middle Name"
                readOnly={!isEditMode} value={middleName} onChange={(e) => setMiddleName(e.target.value)}
                /></div>
            </div>
          </div>
          <div className="major-info-right-item info-item-holder row">
            <div className="info-item info-item3 column">
              <div className="info-item-label">Extension Name</div>
              <div className="info-item-input">
                <input id="AddEmployee-ExtensionName" placeholder="Extension Name"
                readOnly={!isEditMode} value={extensionName} onChange={(e) => setExtensionName(e.target.value)}
                /></div>
            </div>
            <div className="info-item info-item3 column">
              <div className="info-item-label">Nick Name</div>
              <div className="info-item-input">
                <input id="AddEmployee-NickName" placeholder="Nick Name"
                readOnly={!isEditMode} value={nickName} onChange={(e) => setNickName(e.target.value)}
                /></div>
            </div>
            <div className="info-item info-item3 column">
              <div className="info-item-label">Gender</div>
              <div className="info-item-input">{Gender(gender, setGender, isEditMode)}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="minor-info column">
        <div className="minor-info-item info-item-holder row">
          <div className="info-item info-item4 column">
            <div className="info-item-label">Civil Status</div>
            <div className="info-item-input">{CivilStatus(civilStatus, setCivilStatus, isEditMode)}</div>
          </div>
          <div className="info-item info-item4 column">
            <div className="info-item-label">Citizenship</div>
            <div className="info-item-input">
              <input id="AddEmployee-Citizenship" placeholder="Citizenship"
              readOnly={!isEditMode} value={citizenship} onChange={(e) => setCitizenship(e.target.value)}
              /></div>
          </div>
          <div className="info-item info-item4 column">
            <div className="info-item-label">Religion</div>
            <div className="info-item-input">
              <input id="AddEmployee-Religion" placeholder="Religion"
              readOnly={!isEditMode} value={religion} onChange={(e) => setReligion(e.target.value)}
              /></div>
          </div>
          <div className="info-item info-item4 column">
            <div className="info-item-label">Age</div>
            <div className="info-item-input">
              <input type='number' id="AddEmployee-EmployeeId" placeholder="Age"
              readOnly={!isEditMode} value={age} onChange={(e) => setAge(e.target.value)}
              /></div>
          </div>
        </div>
        <div className="minor-info-item info-item-holder row">
          <div className="info-item info-item4 column">
            <div className="info-item-label">Date Of Birth</div>
            <div className="info-item-input">
              {DateInput(dateOfBirth, setDateOfBirth, isEditMode)}
            </div>
          </div>
          <div className="info-item info-item4 column">
            <div className="info-item-label">Place Of Birth</div>
            <div className="info-item-input">
              <input id="AddEmployee-PlaceOfBirth" placeholder="Place Of Birth"
              readOnly={!isEditMode} value={placeOfBirth} onChange={(e) => setPlaceOfBirth(e.target.value)}
              /></div>
          </div>
          <div className="info-item info-item4 column">
            <div className="info-item-label">Blood Type</div>
            <div className="info-item-input">
              <input id="AddEmployee-BloodType" placeholder="Blood Type"
              readOnly={!isEditMode} value={bloodType} onChange={(e) => setBloodType(e.target.value)}
              /></div>
          </div>
          <div className="info-item info-item4 column">
            <div className="info-item-label">Mobile Number</div>
            <div className="info-item-input">
              <input id="AddEmployee-MobileNumber" placeholder="Mobile Number"
              readOnly={!isEditMode} value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)}
              /></div>
          </div>
        </div>
        <div className="minor-info-item info-item-holder row" style={{justifyContent:"normal"}}>
          <div className="info-item info-item4 column">
            <div className="info-item-label">Email Address</div>
            <div className="info-item-input">
              <input id="AddEmployee-EmailAddress" placeholder="Email Address"
              readOnly={!isEditMode} value={emailAddress} onChange={(e) => setEmailAddress(e.target.value)}
              /></div>
          </div>
          <div className="info-item info-item4 column">
            <div className="info-item-label">Height</div>
            <div className="info-item-input">
              <input id="AddEmployee-Height" placeholder="Height"
              readOnly={!isEditMode} value={height} onChange={(e) => setHeight(e.target.value)}
              /></div>
          </div>
          <div className="info-item info-item4 column">
            <div className="info-item-label">Weight</div>
            <div className="info-item-input">
              <input id="AddEmployee-Weight" placeholder="Weight"
              readOnly={!isEditMode} value={weight} onChange={(e) => setWeight(e.target.value)}
              /></div>
          </div>
        </div>
        <div className="minor-info-item info-item-holder row" style={{justifyContent:"normal"}}>
          <div className="transaction-form-item row" style={{paddingTop:"50px", alignItems:"revert"}}>
              <div className="transaction-form-category"><h4 style={{margin:'0', fontWeight: "bold"}}>Signature: </h4></div>
              <div className="transaction-form-input">

                  {isEditMode && 
                    <>
                      <label htmlFor="fileInput" className='browse'>Browse...</label>
                      <input
                          type="file"
                          id="fileInput"
                          onChange={(e)=> handleBrowse(e)}
                          style={{ display: 'none' }}
                      />
                    </>
                  }
                  
                  {signature.length > 0 ? (
                      <div style={{border:"1px solid #97979745", padding:"10px"}}>
                          <span>Uploaded File:</span>
                          <ul>
                              {signature.map((file, index) => (
                              <img src={file ? URL.createObjectURL(file) : "images/sample.jpg"} alt="" style={{width: "150px", height: "auto"}}></img>
                              ))}
                          </ul>
                          {isEditMode && <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                              <button id="add-family" 
                              className="cancel row"
                              onClick={()=>clearFiles()}
                              style={{marginRight:"5px"}}>
                                  CLEAR
                              </button>
                          </div>}
                      </div>
                  )
                  :
                  (
                      isEditMode &&
                        <div
                          id='drop-files-here'
                          onDrop={(e)=>handleDrop(e)}
                          onDragOver={(e)=>handleDragOver(e)}
                          onDragLeave={(e)=>handleDragOut(e)}
                          style={{
                          border: '2px dashed #ccc',
                          borderRadius: '5px',
                          padding: '20px',
                          marginTop: '10px',
                          textAlign: 'center',
                          }}
                      >
                          Drop files here
                      </div>
                  )}
              </div>
          </div>
        </div>
      </div>
    </div>
  )
}
function AddressTab({
  blkLot,
  street,
  barangay,
  city,
  postalCode,
  yearsOfStay,
  setBlkLot,
  setStreet,
  setBarangay,
  setCity,
  setPostalCode,
  setYearsOfStay,
  isEditMode
}){
  return (
    <div className="address-tab column">
      <div className="address-tab-itemHolder info-item-holder row">
        <div className="info-item info-item3 column">
          <div className="info-item-label">Blk/Lot</div>
          <div className="info-item-input">
            <input id="AddEmployee-BlkLot" placeholder="Blk/Lot"
            readOnly={!isEditMode} value={blkLot} onChange={(e) => setBlkLot(e.target.value)}
            /></div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Street</div>
          <div className="info-item-input">
            <input id="AddEmployee-Street" placeholder="Street"
            readOnly={!isEditMode} value={street} onChange={(e) => setStreet(e.target.value)}
            /></div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Barangay</div>
          <div className="info-item-input">
            <input id="AddEmployee-Barangay" placeholder="Barangay"
            readOnly={!isEditMode} value={barangay} onChange={(e) => setBarangay(e.target.value)}
            /></div>
        </div>
      </div>
      <div className="address-tab-itemHolder info-item-holder row">
        <div className="info-item info-item3 column">
          <div className="info-item-label">City</div>
          <div className="info-item-input">
            <input id="AddEmployee-City" placeholder="City"
            readOnly={!isEditMode} value={city} onChange={(e) => setCity(e.target.value)}
            /></div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Postal Code</div>
          <div className="info-item-input">
            <input id="AddEmployee-PostalCode" placeholder="Postal Code"
            readOnly={!isEditMode} value={postalCode} onChange={(e) => setPostalCode(e.target.value)}
            /></div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Years Of Stay</div>
          <div className="info-item-input">
            <input id="AddEmployee-YearsOfStay" type="number" placeholder="Years Of Stay"
            readOnly={!isEditMode} value={yearsOfStay} onChange={(e) => setYearsOfStay(e.target.value)}
            /></div>
        </div>
      </div>
    </div>
  )
}
function InformationTab({
  locationId,
  dateEmployed,
  dateRegular,
  dateProbationary,
  dateProjectBase,
  dateContractual,
  dateResigned,
  employmentId,
  departmentId,
  sectionId,
  classificationId,
  payTypeId,
  shiftScheduleId,
  positionId,
  salaryType,
  setLocationId,
  setDateEmployed,
  setDateRegular,
  setDateProbationary,
  setDateProjectBase,
  setDateContractual,
  setDateResigned,
  setEmploymentId,
  setDepartmentId,
  setSectionId,
  setClassificationId,
  setPayTypeId,
  setShiftScheduleId,
  setPositionId,
  setSalaryType,
  sickLeave,
  setSickLeave,
  vacationLeave,
  setVacationLeave,
  employeeStatus,
  setEmployeeStatus,
  serviceIncentiveLeave,
  setServiceIncentiveLeave,
  soloParentLeave,
  setSoloParentLeave,

  sickRemaining,
  setSickRemaining,
  vacationRemaining,
  setVacationRemaining,
  serviceIncentiveRemaining,
  setServiceIncentiveRemaining,
  soloParentRemaining,
  setSoloParentRemaining,
  isEditMode,

  jobTitleId, setJobTitleId,
  employeeGroup1Id, setEmployeeGroup1Id,
  employeeGroup2Id, setEmployeeGroup2Id,
  plantilyaId,
  setPlantilyaId,
  costCenterId,
  setCostCenterId,
  clientId,
  setClientId,
  hasMobileRegisterFeature,
  setHasMobileRegisterFeature,
  hasMobileInAndOut,
  setHasMobileInAndOut,

  employeeRestDays, setEmployeeRestDays
}){
  const [isMonday, setIsMonday] = useState(false);
  const [isTuesday, setIsTuesday] = useState(false);
  const [isWednesday, setIsWednesday] = useState(false);
  const [isThursday, setIsThursday] = useState(false);
  const [isFriday, setIsFriday] = useState(false);
  const [isSaturday, setIsSaturday] = useState(false);
  const [isSunday, setIsSunday] = useState(false);

  const [isInitOnce, setIsInitOnce] = useState(false);

  useEffect(() => {
    if(!isInitOnce){
      setIsInitOnce(true);

      const haveMonday = employeeRestDays.find(data => data.day === "Monday");
      const haveTuesday = employeeRestDays.find(data => data.day === "Tuesday");
      const haveWednesday = employeeRestDays.find(data => data.day === "Wednesday");
      const haveThursday = employeeRestDays.find(data => data.day === "Thursday");
      const haveFriday = employeeRestDays.find(data => data.day === "Friday");
      const haveSaturday = employeeRestDays.find(data => data.day === "Saturday");
      const haveSunday = employeeRestDays.find(data => data.day === "Sunday");

      setIsMonday(haveMonday ? true : false);
      setIsTuesday(haveTuesday ? true : false);
      setIsWednesday(haveWednesday ? true : false);
      setIsThursday(haveThursday ? true : false);
      setIsFriday(haveFriday ? true : false);
      setIsSaturday(haveSaturday ? true : false);
      setIsSunday(haveSunday ? true : false);
    }
  }, [employeeRestDays, isInitOnce])

  useEffect(() => {
    const days = [
      { day: 'Monday', isRestDay: isMonday },
      { day: 'Tuesday', isRestDay: isTuesday },
      { day: 'Wednesday', isRestDay: isWednesday },
      { day: 'Thursday', isRestDay: isThursday },
      { day: 'Friday', isRestDay: isFriday },
      { day: 'Saturday', isRestDay: isSaturday },
      { day: 'Sunday', isRestDay: isSunday },
    ];

    // Filter the days where isRestDay is true and map them to the desired format
    const restDays = days
      .filter(dayObj => dayObj.isRestDay)
      .map(dayObj => ({
        day: dayObj.day,
      }));
    // Set the state with the rest days
    setEmployeeRestDays(restDays);
  }, [isMonday, isTuesday, isWednesday, isThursday, isFriday, isSaturday, isSunday, setEmployeeRestDays])

  return (
    <div className="information-tab column">
      <div className="information-tab-itemHolder info-item-holder row" style={{justifyContent:"normal"}}>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{alignItems:"center"}}>Location<span style={{visibility: isEditMode ? "visible" : "hidden", color:"red",fontSize:"10px", marginLeft:"5px"}}>(*required)</span></div>
          <div className="info-item-input">{LocationIdSelect(locationId, setLocationId, isEditMode)}</div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Date Employed</div>
          <div className="info-item-input">{DateInput(dateEmployed, setDateEmployed, isEditMode)}</div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Date Regular</div>
          <div className="info-item-input">{DateInput(dateRegular, setDateRegular, isEditMode)}</div>
        </div>
      </div>
      <div className="information-tab-itemHolder info-item-holder row" style={{justifyContent:"normal"}}>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Date Probationary</div>
          <div className="info-item-input">{DateInput(dateProbationary, setDateProbationary, isEditMode)}</div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Date Project Base</div>
          <div className="info-item-input">{DateInput(dateProjectBase, setDateProjectBase, isEditMode)}</div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Date Contractual</div>
          <div className="info-item-input">{DateInput(dateContractual, setDateContractual, isEditMode)}</div>
        </div>
      </div>
      <div className="information-tab-itemHolder info-item-holder row" style={{justifyContent:"normal"}}>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{alignItems:"center"}}>Employment<span style={{visibility: isEditMode ? "visible" : "hidden", color:"red",fontSize:"10px", marginLeft:"5px"}}>(*required)</span></div>
          <div className="info-item-input">{EmploymentId(employmentId, setEmploymentId, isEditMode)}</div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{alignItems:"center"}}>Department<span style={{visibility: isEditMode ? "visible" : "hidden", color:"red",fontSize:"10px", marginLeft:"5px"}}>(*required)</span></div>
          <div className="info-item-input">{DepartmentIdSelect(departmentId, setDepartmentId, isEditMode)}</div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{alignItems:"center"}}>Section<span style={{visibility: isEditMode ? "visible" : "hidden", color:"red",fontSize:"10px", marginLeft:"5px"}}>(*required)</span></div>
          <div className="info-item-input">{SectionIdSelect(sectionId, setSectionId, isEditMode)}</div>
        </div>
      </div>
      <div className="information-tab-itemHolder info-item-holder row" style={{justifyContent:"normal"}}>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{alignItems:"center"}}>Classification<span style={{visibility: isEditMode ? "visible" : "hidden", color:"red",fontSize:"10px", marginLeft:"5px"}}>(*required)</span></div>
          <div className="info-item-input">{ClassificationIdSelect(classificationId, setClassificationId, isEditMode)}</div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{alignItems:"center"}}>Pay Type<span style={{visibility: isEditMode ? "visible" : "hidden", color:"red",fontSize:"10px", marginLeft:"5px"}}>(*required)</span></div>
          <div className="info-item-input">{PayTypeIdSelect(payTypeId, setPayTypeId, isEditMode)}</div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{alignItems:"center"}}>Shift Schedule<span style={{visibility: isEditMode ? "visible" : "hidden", color:"red",fontSize:"10px", marginLeft:"5px"}}>(*required)</span></div>
          <div className="info-item-input">{ShiftScheduleIdSelect(shiftScheduleId, setShiftScheduleId, isEditMode)}</div>
        </div>
      </div>
      <div className="information-tab-itemHolder info-item-holder row" style={{justifyContent:"normal"}}>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{alignItems:"center"}}>Position<span style={{visibility: isEditMode ? "visible" : "hidden", color:"red",fontSize:"10px", marginLeft:"5px"}}>(*required)</span></div>
          <div className="info-item-input">{PositionIdSelect(positionId, setPositionId, isEditMode)}</div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{alignItems:"center"}}>Salary Type</div>
          <div className="info-item-input">
            <SalaryType salaryType={salaryType} setSalaryType={setSalaryType} isEditMode={isEditMode}/>
          </div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{alignItems:"center"}}>Employee Status</div>
          <div className="info-item-input">
            <EmployeeStatus employeeStatus={employeeStatus} setEmployeeStatus={setEmployeeStatus} isEditMode={isEditMode}/>
          </div>
        </div>
      </div>
      <div className="information-tab-itemHolder info-item-holder row" style={{justifyContent:"normal"}}>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{alignItems:"center"}}>Job Title</div>
          <div className="info-item-input">
            <JobTitleIdSelect jobTitleId={jobTitleId} setJobTitleId={setJobTitleId} isEditMode={isEditMode}/>
          </div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{alignItems:"center"}}>Employee Group 1</div>
          <div className="info-item-input">
            <EmployeeGroup1IdSelect employeeGroup1Id={employeeGroup1Id} setEmployeeGroup1Id={setEmployeeGroup1Id} isEditMode={isEditMode}/>
          </div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{alignItems:"center"}}>Employee Group 2</div>
          <div className="info-item-input">
            <EmployeeGroup2IdSelect employeeGroup2Id={employeeGroup2Id} setEmployeeGroup2Id={setEmployeeGroup2Id} isEditMode={isEditMode}/>
          </div>
        </div>
      </div>
      <div className="information-tab-itemHolder info-item-holder row" style={{justifyContent:"normal"}}>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{alignItems:"center"}}>Plantilya</div>
          <div className="info-item-input">
            <PlantilyaIdSelect plantilyaId={plantilyaId} setPlantilyaId={setPlantilyaId} isEditMode={isEditMode}/>
          </div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{alignItems:"center"}}>Cost Center</div>
          <div className="info-item-input">
            <CostCenterSelect costCenterId={costCenterId} setCostCenterId={setCostCenterId} isEditMode={isEditMode}/>
          </div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{alignItems:"center"}}>Client</div>
          <div className="info-item-input">
            <ClientIdSelect clientId={clientId} setClientId={setClientId} isEditMode={isEditMode}/>
          </div>
        </div>
      </div>
      <div className="flex flex-row gap-2 py-4 items-center">
        <input 
            type="checkbox" 
            className="checkbox w-5 h-5" 
            name="" 
            checked={hasMobileRegisterFeature}
            onChange={(e) => setHasMobileRegisterFeature(e.target.checked)}
            disabled={!isEditMode}
        />
        <span className='font-bold text-gray-500'>Has Mobile Register Feature?</span>
      </div>
      <div className="flex flex-row gap-2 py-4 items-center">
        <input 
            type="checkbox" 
            className="checkbox w-5 h-5" 
            name="" 
            checked={hasMobileInAndOut}
            onChange={(e) => setHasMobileInAndOut(e.target.checked)}
            disabled={!isEditMode}
        />
        <span className='font-bold text-gray-500'>Has Mobile In and Out?</span>
      </div>
      <div className="information-tab-itemHolder info-item-holder row" style={{justifyContent:"normal"}}>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Date Resigned</div>
          <div className="info-item-input">{DateInput(dateResigned, setDateResigned, isEditMode)}</div>
        </div>
      </div>
      <div className="information-tab-itemHolder info-item-holder row" style={{justifyContent:"normal"}}>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{alignItems:"center"}}>Vacation Leave</div>
          <div className="info-item-input">
            <input id="AddEmployee-EmployeeId" placeholder="Vacation leave amount"
            type="number" value={vacationLeave} onChange={(e) => setVacationLeave(e.target.value)}
            readOnly={!isEditMode}
            />
          </div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{alignItems:"center"}}>Sick Leave</div>
          <div className="info-item-input">
            <input id="AddEmployee-EmployeeId" placeholder="Sick leave amount"
            type="number" value={sickLeave} onChange={(e) => setSickLeave(e.target.value)}
            readOnly={!isEditMode}
            />
          </div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{alignItems:"center"}}>Service Incentive Leave</div>
          <div className="info-item-input">
            <input id="AddEmployee-EmployeeId" placeholder="Service incentive leave amount"
            type="number" value={serviceIncentiveLeave} onChange={(e) => setServiceIncentiveLeave(e.target.value)}
            readOnly={!isEditMode}
            />
          </div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{alignItems:"center"}}>Solo Parent Leave</div>
          <div className="info-item-input">
            <input id="AddEmployee-EmployeeId" placeholder="Service incentive leave amount"
            type="number" value={soloParentLeave} onChange={(e) => setSoloParentLeave(e.target.value)}
            readOnly={!isEditMode}
            />
          </div>
        </div>
      </div>
      <div className="information-tab-itemHolder info-item-holder row" style={{justifyContent:"normal"}}>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{alignItems:"center"}}>Vacation Remaining Leave</div>
          <div className="info-item-input">
            <input id="AddEmployee-EmployeeId" placeholder="Vacation leave remaining amount"
            type="number" value={vacationRemaining} onChange={(e) => setVacationRemaining(e.target.value)}
            readOnly={!isEditMode}
            />
          </div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{alignItems:"center"}}>Sick Remaining Leave</div>
          <div className="info-item-input">
            <input id="AddEmployee-EmployeeId" placeholder="Sick leave remaining amount"
            type="number" value={sickRemaining} onChange={(e) => setSickRemaining(e.target.value)}
            readOnly={!isEditMode}
            />
          </div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{alignItems:"center"}}>Service Incentive Remaining Leave</div>
          <div className="info-item-input">
            <input id="AddEmployee-EmployeeId" placeholder="Service incentive leave remaining amount"
            type="number" value={serviceIncentiveRemaining} onChange={(e) => setServiceIncentiveRemaining(e.target.value)}
            readOnly={!isEditMode}
            />
          </div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label row" style={{alignItems:"center"}}>Solo Parent Remaining Leave</div>
          <div className="info-item-input">
            <input id="AddEmployee-EmployeeId" placeholder="Service incentive leave remaining amount"
            type="number" value={soloParentRemaining} onChange={(e) => setSoloParentRemaining(e.target.value)}
            readOnly={!isEditMode}
            />
          </div>
        </div>
      </div>
      <div style={{border: "1px solid rgba(0, 0, 0, 0.357)", padding: "20px 5px", margin: "20px 0"}}>
        <div className="info-item-label row" style={{alignItems:"center"}}>Restday/s</div>
        <div className="information-tab-itemHolder info-item-holder row" style={{justifyContent: "space-evenly"}}>
          <div className="info-item info-item column">
            <div className="info-item-label row" style={{alignItems:"center"}}>Monday</div>
            <div className="info-item-input">
              <input 
                  type="checkbox" 
                  id="overtime-allowance" 
                  className="checkbox" 
                  name="" 
                  checked={isMonday}
                  onChange={(e) => setIsMonday(e.target.checked)}
                  disabled={!isEditMode}
              />
            </div>
          </div>
          <div className="info-item info-item column">
            <div className="info-item-label row" style={{alignItems:"center"}}>Tuesday</div>
            <div className="info-item-input">
              <input 
                  type="checkbox" 
                  id="overtime-allowance" 
                  className="checkbox" 
                  name="" 
                  checked={isTuesday}
                  onChange={(e) => setIsTuesday(e.target.checked)}
                  disabled={!isEditMode}
              />
            </div>
          </div>
          <div className="info-item info-item column">
            <div className="info-item-label row" style={{alignItems:"center"}}>Wednesday</div>
            <div className="info-item-input">
              <input 
                  type="checkbox" 
                  id="overtime-allowance" 
                  className="checkbox" 
                  name="" 
                  checked={isWednesday}
                  onChange={(e) => setIsWednesday(e.target.checked)}
                  disabled={!isEditMode}
              />
            </div>
          </div>
          <div className="info-item info-item column">
            <div className="info-item-label row" style={{alignItems:"center"}}>Thursday</div>
            <div className="info-item-input">
              <input 
                  type="checkbox" 
                  id="overtime-allowance" 
                  className="checkbox" 
                  name="" 
                  checked={isThursday}
                  onChange={(e) => setIsThursday(e.target.checked)}
                  disabled={!isEditMode}
              />
            </div>
          </div>
          <div className="info-item info-item column">
            <div className="info-item-label row" style={{alignItems:"center"}}>Friday</div>
            <div className="info-item-input">
              <input 
                  type="checkbox" 
                  id="overtime-allowance" 
                  className="checkbox" 
                  name="" 
                  checked={isFriday}
                  onChange={(e) => setIsFriday(e.target.checked)}
                  disabled={!isEditMode}
              />
            </div>
          </div>
          <div className="info-item info-item column">
            <div className="info-item-label row" style={{alignItems:"center"}}>Saturday</div>
            <div className="info-item-input">
              <input 
                  type="checkbox" 
                  id="overtime-allowance" 
                  className="checkbox" 
                  name="" 
                  checked={isSaturday}
                  onChange={(e) => setIsSaturday(e.target.checked)}
                  disabled={!isEditMode}
              />
            </div>
          </div>
          <div className="info-item info-item column">
            <div className="info-item-label row" style={{alignItems:"center"}}>Sunday</div>
            <div className="info-item-input">
              <input 
                  type="checkbox" 
                  id="overtime-allowance" 
                  className="checkbox" 
                  name="" 
                  checked={isSunday}
                  onChange={(e) => setIsSunday(e.target.checked)}
                  disabled={!isEditMode}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
function AccountsTab({
  sss,
  tin,
  passport,
  philhealth,
  pagibig,
  setsss,
  setTin,
  setPassport,
  setPhilhealth,
  setPagibig,
  isEditMode
}){
  return (
    <div className="accounts-tab column">
      <div className="accounts-tab-itemHolder info-item-holder row" style={{justifyContent:"normal"}}>
        <div className="info-item info-item3 column">
          <div className="info-item-label">SSS Number</div>
          <div className="info-item-input">
            <input id="AddEmployee-SSSNumber" placeholder="SSS Number"
            readOnly={!isEditMode} value={sss} onChange={(e)=>setsss(e.target.value)}
            /></div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Tin Number</div>
          <div className="info-item-input">
            <input id="AddEmployee-TinNumber" placeholder="Tin Number"
            readOnly={!isEditMode} value={tin} onChange={(e)=>setTin(e.target.value)}
            /></div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Passport Number</div>
          <div className="info-item-input">
            <input id="AddEmployee-PassportNumber" placeholder="Passport Number"
            readOnly={!isEditMode} value={passport} onChange={(e)=>setPassport(e.target.value)}
            /></div>
        </div>
      </div>
      <div className="accounts-tab-itemHolder info-item-holder row" style={{justifyContent:"normal"}}>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Philhealth Number</div>
          <div className="info-item-input">
            <input id="AddEmployee-PhilhealthNumber" placeholder="Philhealth Number"
            readOnly={!isEditMode} value={philhealth} onChange={(e)=>setPhilhealth(e.target.value)}
            /></div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Pagibig Number</div>
          <div className="info-item-input">
            <input id="AddEmployee-PagibigNumber" placeholder="Pagibig Number"
            readOnly={!isEditMode} value={pagibig} onChange={(e)=>setPagibig(e.target.value)}
            /></div>
        </div>
      </div>
    </div>
  )
}
function EducationsTab({
  employeeId,
  employeeEducationAttainments,
  setEmployeeEducationAttainments,
  isEditMode
}){
  const [data, setData] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [editData, setEditData] = useState([]);
  const [editId, setEditId] = useState("");

  useEffect(() => {
    setData(employeeEducationAttainments);
  }, [employeeEducationAttainments]);

  const openForm = () =>{
    if(!employeeId){
      alert("Please finish personal information first")
      return;
    }
    setShowForm(true);
  }
  const closeForm = () =>{
    setShowForm(false);
  }
  const closeEditForm = () =>{
    setShowEditForm(false);
  }
  const editHandleClick = (_data) => {
    setEditData(_data);
    setShowEditForm(true);
    const index = data.findIndex(item => 
      item.employeePersonalInformationId === _data.employeePersonalInformationId &&
      item.level === _data.level &&
      item.schoolName === _data.schoolName &&
      item.address === _data.address &&
      item.course === _data.course &&
      item.honors === _data.honors &&
      item.dateFrom === _data.dateFrom &&
      item.dateTo === _data.dateTo
    );
    setEditId(index);
  };
  const deleteHandleClick = (_data) => {
    const index = data.findIndex(item => 
      item.employeePersonalInformationId === _data.employeePersonalInformationId &&
      item.level === _data.level &&
      item.schoolName === _data.schoolName &&
      item.address === _data.address &&
      item.course === _data.course &&
      item.honors === _data.honors &&
      item.dateFrom === _data.dateFrom &&
      item.dateTo === _data.dateTo
    );
    deleteData(index);
  };

  var header = [
    "Level",
    "School Name",
    "Address",
    "Date From", 
    "Date To", 
    "Course",
    "Honors",
    "",
  ]
  var accessor = [
      "level",
      "schoolName",
      "address",
      "dateFrom",
      "dateTo",
      "course",
      "honors",
      "manage"
  ]
  const addEmployeesEducation = (employeePersonalInformationId, level, schoolName, address, dateFrom, dateTo, course, honors) => {
    const newData = {
      "employeePersonalInformationId":employeePersonalInformationId,
      "level": level,
      "schoolName": schoolName,
      "address": address,
      "course": course,
      "honors": honors,
      "dateFrom": dateFrom,
      "dateTo": dateTo,
      "manage": ""
    };

    setData([...data, newData]);
    setEmployeeEducationAttainments([...employeeEducationAttainments, newData]);
    closeForm();
  };
  const updateData = (employeePersonalInformationId, level, schoolName, address, dateFrom, dateTo, course, honors) => {
    const newData = {
      "employeePersonalInformationId":employeePersonalInformationId,
      "level": level,
      "schoolName": schoolName,
      "address": address,
      "course": course,
      "honors": honors,
      "dateFrom": dateFrom,
      "dateTo": dateTo,
      "manage": ""
    };

    setData(prevValue => {
      const newValue = [...prevValue]; // Create a copy of the original array
      newValue[editId] = newData; // Set newData at the specified index
      return newValue; // Update the state with the new array
    });
    setEmployeeEducationAttainments(prevValue => {
      const newValue = [...prevValue]; // Create a copy of the original array
      newValue[editId] = newData; // Set newData at the specified index
      return newValue; // Update the state with the new array
    });

    closeEditForm();
  };
  const deleteData = (index) => {
    setData(prevValue => {
      const newValue = [...prevValue];
      newValue.splice(index, 1);
      return newValue;
    });
    setEmployeeEducationAttainments(prevValue => {
      const newValue = [...prevValue];
      newValue.splice(index, 1);
      return newValue;
    });
  };

  return (
    <div className="educations-tab">
      <div className="educations-tab-top" style={{display:isEditMode? "flex" : "none", justifyContent:"start"}}>
        {CreateButton("addEmployee-education-add", "add row", ()=>openForm(), "ADD", GroupAddIcon)}
      </div>
      <div className="educations-tab-body">
        <div className="employeesTab-table container">
            <CreateTable
              dataList={data}
              dataHeader={header}
              dataAccessor={accessor}
              editHandleClick={editHandleClick}
              deleteHandleClick={deleteHandleClick}
              isEditMode={isEditMode}
            />
            {data.length > 0 ? (
              <div></div>
            )
            :
            (
                <div> {/*<p>No records to display</p>*/}</div>
            )}
          </div>
      </div>
      <EducationAddForm isOpen={showForm} 
                    onClose={closeForm}
                    employeeId={employeeId}
                    addEmployeesEducation={addEmployeesEducation}/>
      <EducationEditForm isOpen={showEditForm} 
                    onClose={closeEditForm}
                    editData={editData}
                    employeeId={employeeId}
                    addEmployeesEducation={updateData}/>
    </div>
  )
}
function DependentsTab({
  employeeId,
  employeeDependents,
  setEmployeeDependents,
  isEditMode
}){
  const [data, setData] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [editData, setEditData] = useState([]);
  const [editId, setEditId] = useState("");

  useEffect(() => {
    setData(employeeDependents);
  }, [employeeDependents]);

  const openForm = () =>{
    if(!employeeId){
      alert("Please finish personal information first")
      return;
    }
    setShowForm(true);
  }
  const closeForm = () =>{
    setShowForm(false);
  }
  const closeEditForm = () =>{
    setShowEditForm(false);
  }
  const editHandleClick = (_data) => {
    setEditData(_data);
    setShowEditForm(true);
    const index = data.findIndex(item => 
      item.employeePersonalInformationId === _data.employeePersonalInformationId &&
      item.lastName === _data.lastName &&
      item.middleName === _data.middleName &&
      item.extensionName === _data.extensionName &&
      item.dateOfBirth === _data.dateOfBirth &&
      item.gender === _data.gender &&
      item.civilStatus === _data.civilStatus
    );
    setEditId(index);
  };
  const deleteHandleClick = (_data) => {
    const index = data.findIndex(item => 
      item.employeePersonalInformationId === _data.employeePersonalInformationId &&
      item.lastName === _data.lastName &&
      item.middleName === _data.middleName &&
      item.extensionName === _data.extensionName &&
      item.dateOfBirth === _data.dateOfBirth &&
      item.gender === _data.gender &&
      item.civilStatus === _data.civilStatus
    );
    deleteData(index);
  };

  var header = [
    "Last Name",
    "First Name",
    "Middle Name",
    "Extension Name",
    "Date Of Birth",
    "Gender",
    "Civil Status",
    "",
]
  var accessor = [
    "lastName",
    "firstName",
    "middleName",
    "extensionName",
    "dateOfBirth",
    "gender",
    "civilStatus",
    "manage"
  ]

  const addEmployeesDependets = (employeePersonalInformationId, lastName, firstName, middleName, extensionName, dateOfBirth, gender, civilStatus) => {
    const newData = {
      "employeePersonalInformationId":employeePersonalInformationId,
      "lastName": lastName,
      "firstName": firstName,
      "middleName": middleName,
      "extensionName": extensionName,
      "dateOfBirth": dateOfBirth,
      "gender": gender,
      "civilStatus": civilStatus,
      "manage": ""
    };

    setData([...data, newData]);
    setEmployeeDependents([...employeeDependents, newData]);
    closeForm();
  };
  const updateData = (employeePersonalInformationId, lastName, firstName, middleName, extensionName, dateOfBirth, gender, civilStatus) => {
    const newData = {
      "employeePersonalInformationId":employeePersonalInformationId,
      "lastName": lastName,
      "firstName": firstName,
      "middleName": middleName,
      "extensionName": extensionName,
      "dateOfBirth": dateOfBirth,
      "gender": gender,
      "civilStatus": civilStatus,
      "manage": ""
    };

    setData(prevValue => {
      const newValue = [...prevValue]; // Create a copy of the original array
      newValue[editId] = newData; // Set newData at the specified index
      return newValue; // Update the state with the new array
    });
    setEmployeeDependents(prevValue => {
      const newValue = [...prevValue]; // Create a copy of the original array
      newValue[editId] = newData; // Set newData at the specified index
      return newValue; // Update the state with the new array
    });

    closeEditForm();
  };
  const deleteData = (index) => {
    setData(prevValue => {
      const newValue = [...prevValue];
      newValue.splice(index, 1);
      return newValue;
    });
    setEmployeeDependents(prevValue => {
      const newValue = [...prevValue];
      newValue.splice(index, 1);
      return newValue;
    });
  };

  return (
    <div className="dependents-tab">
      <div className="dependents-tab-top"  style={{display:isEditMode? "flex" : "none", justifyContent:"start"}}>
        {CreateButton("addEmployee-dependents-add", "add row", ()=>openForm(), "ADD", GroupAddIcon)}
      </div>
      <div className="dependents-tab-body">
        <div className="employeesTab-table container">
            <CreateTable
              dataList={data}
              dataHeader={header}
              dataAccessor={accessor}
              editHandleClick={editHandleClick}
              deleteHandleClick={deleteHandleClick}
              isEditMode={isEditMode}
            />
            {data.length > 0 ? (
              <div></div>
            )
            :
            (
                <div> {/*<p>No records to display</p>*/}</div>
            )}
          </div>
      </div>
      <DependentsAddForm isOpen={showForm} 
                    onClose={closeForm}
                    employeeId={employeeId}
                    addEmployeesDependets={addEmployeesDependets}/>
      <DependentsEditForm isOpen={showEditForm} 
                    onClose={closeEditForm}
                    editData={editData}
                    employeeId={employeeId}
                    addEmployeesDependets={updateData}/>
    </div>
  )
}
function EmergencyTab({
  employeeId,
  employeeEmergencyContacts,
  setEmployeeEmergencyContacts,
  isEditMode
}){
  const [data, setData] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [editData, setEditData] = useState([]);
  const [editId, setEditId] = useState("");

  useEffect(() => {
    setData(employeeEmergencyContacts);
  }, [employeeEmergencyContacts]);

  const openForm = () =>{
    if(!employeeId){
      alert("Please finish personal information first")
      return;
    }
    setShowForm(true);
  }
  const closeForm = () =>{
    setShowForm(false);
  }
  const closeEditForm = () =>{
    setShowEditForm(false);
  }
  const editHandleClick = (_data) => {
    setEditData(_data);
    setShowEditForm(true);
    const index = data.findIndex(item => 
      item.employeePersonalInformationId === _data.employeePersonalInformationId &&
      item.name === _data.name &&
      item.relationship === _data.relationship &&
      item.contactNumber === _data.contactNumber &&
      item.address === _data.address 
    );
    setEditId(index);
  };
  const deleteHandleClick = (_data) => {
    const index = data.findIndex(item => 
      item.employeePersonalInformationId === _data.employeePersonalInformationId &&
      item.name === _data.name &&
      item.relationship === _data.relationship &&
      item.contactNumber === _data.contactNumber &&
      item.address === _data.address 
    );
    deleteData(index);
  };

  var header = [
    "Name",
    "Relationship",
    "Contact Number",
    "Address",
    "",
]
  var accessor = [
    "name",
    "relationship",
    "contactNumber",
    "address",
    "manage"
  ]

  const addEmployeesEmergency = (employeePersonalInformationId, name, relationship, contactNumber, address) => {
    const newData = {
      "employeePersonalInformationId":employeePersonalInformationId,
      "name": name,
      "relationship": relationship,
      "contactNumber": contactNumber,
      "address": address,
      "manage": ""
    };

    setData([...data, newData]);
    setEmployeeEmergencyContacts([...employeeEmergencyContacts, newData]);
    closeForm();
  };
  const updateData = (employeePersonalInformationId, name, relationship, contactNumber, address) => {
    const newData = {
      "employeePersonalInformationId":employeePersonalInformationId,
      "name": name,
      "relationship": relationship,
      "contactNumber": contactNumber,
      "address": address,
      "manage": ""
    };

    setData(prevValue => {
      const newValue = [...prevValue]; // Create a copy of the original array
      newValue[editId] = newData; // Set newData at the specified index
      return newValue; // Update the state with the new array
    });
    setEmployeeEmergencyContacts(prevValue => {
      const newValue = [...prevValue]; // Create a copy of the original array
      newValue[editId] = newData; // Set newData at the specified index
      return newValue; // Update the state with the new array
    });

    closeEditForm();
  };
  const deleteData = (index) => {
    setData(prevValue => {
      const newValue = [...prevValue];
      newValue.splice(index, 1);
      return newValue;
    });
    setEmployeeEmergencyContacts(prevValue => {
      const newValue = [...prevValue];
      newValue.splice(index, 1);
      return newValue;
    });
  };

  return (
    <div className="emergency-tab">
      <div className="emergency-tab-top"  style={{display:isEditMode? "flex" : "none", justifyContent:"start"}}>
        {CreateButton("addEmployee-emergency-add", "add row", ()=>openForm(), "ADD", GroupAddIcon)}
      </div>
      <div className="emergency-tab-body">
        <div className="employeesTab-table container">
            <CreateTable
              dataList={data}
              dataHeader={header}
              dataAccessor={accessor}
              editHandleClick={editHandleClick}
              deleteHandleClick={deleteHandleClick}
              isEditMode={isEditMode}
            />
            {data.length > 0 ? (
              <div></div>
            )
            :
            (
                <div> {/*<p>No records to display</p>*/}</div>
            )}
          </div>
      </div>
      <EmergencyAddForm isOpen={showForm} 
                    onClose={closeForm}
                    employeeId={employeeId}
                    addEmployeesEmergency={addEmployeesEmergency}/>
      <EmergencyEditForm isOpen={showEditForm} 
                    onClose={closeEditForm}
                    editData={editData}
                    employeeId={employeeId}
                    addEmployeesEmergency={updateData}/>
    </div>
  )
}
function FamilyTab({
  employeeId,
  employeeFamilyData,
  setEmployeeFamilyData,
  isEditMode
}){
  const [data, setData] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [editData, setEditData] = useState([]);
  const [editId, setEditId] = useState("");

  useEffect(() => {
    setData(employeeFamilyData);
  }, [employeeFamilyData]);

  const openForm = () =>{
    if(!employeeId){
      alert("Please finish personal information first")
      return;
    }
    setShowForm(true);
  }
  const closeForm = () =>{
    setShowForm(false);
  }
  const closeEditForm = () =>{
    setShowEditForm(false);
  }
  const editHandleClick = (_data) => {
    setEditData(_data);
    setShowEditForm(true);
    const index = data.findIndex(item => 
      item.employeePersonalInformationId === _data.employeePersonalInformationId &&
      item.name === _data.name &&
      item.dateOfBirth === _data.dateOfBirth &&
      item.occupation === _data.occupation &&
      item.age === _data.age &&
      item.address === _data.address &&
      item.relationship === _data.relationship 
    );
    setEditId(index);
  };
  const deleteHandleClick = (_data) => {
    const index = data.findIndex(item => 
      item.employeePersonalInformationId === _data.employeePersonalInformationId &&
      item.name === _data.name &&
      item.dateOfBirth === _data.dateOfBirth &&
      item.occupation === _data.occupation &&
      item.age === _data.age &&
      item.address === _data.address &&
      item.relationship === _data.relationship 
    );
    deleteData(index);
  };

  var header = [
    "Name",
    "Date Of Birth",
    "Occupation",
    "Contact Number",
    "Age",
    "Address",
    "Relationship",
    "",
]
  var accessor = [
    "name",
    "dateOfBirth",
    "occupation",
    "contactNo",
    "age",
    "address",
    "relationship",
    "manage"
  ]

  const addEmployeesFamily = (employeePersonalInformationId, name, dateOfBirth, occupation, contactNo, age, address, relationship) => {
    const newData = {
      "employeePersonalInformationId":employeePersonalInformationId,
      "name": name,
      "dateOfBirth": dateOfBirth,
      "occupation": occupation,
      "contactNo": contactNo,
      "age": age,
      "address": address,
      "relationship": relationship,
      "manage": ""
    };

    setData([...data, newData]);
    setEmployeeFamilyData([...employeeFamilyData, newData]);
    closeForm();
  };
  const updateData = (employeePersonalInformationId, name, dateOfBirth, occupation, contactNo, age, address, relationship) => {
    const newData = {
      "employeePersonalInformationId":employeePersonalInformationId,
      "name": name,
      "dateOfBirth": dateOfBirth,
      "occupation": occupation,
      "contactNo": contactNo,
      "age": age,
      "address": address,
      "relationship": relationship,
      "manage": ""
    };

    setData(prevValue => {
      const newValue = [...prevValue]; // Create a copy of the original array
      newValue[editId] = newData; // Set newData at the specified index
      return newValue; // Update the state with the new array
    });
    setEmployeeFamilyData(prevValue => {
      const newValue = [...prevValue]; // Create a copy of the original array
      newValue[editId] = newData; // Set newData at the specified index
      return newValue; // Update the state with the new array
    });

    closeEditForm();
  };
  const deleteData = (index) => {
    setData(prevValue => {
      const newValue = [...prevValue];
      newValue.splice(index, 1);
      return newValue;
    });
    setEmployeeFamilyData(prevValue => {
      const newValue = [...prevValue];
      newValue.splice(index, 1);
      return newValue;
    });
  };

  return (
    <div className="family-tab">
      <div className="family-tab-top"  style={{display:isEditMode? "flex" : "none", justifyContent:"start"}}>
        {CreateButton("addEmployee-family-add", "add row", ()=>openForm(), "ADD", GroupAddIcon)}
      </div>
      <div className="family-tab-body">
        <div className="employeesTab-table container">
            <CreateTable
              dataList={data}
              dataHeader={header}
              dataAccessor={accessor}
              editHandleClick={editHandleClick}
              deleteHandleClick={deleteHandleClick}
              isEditMode={isEditMode}
            />
            {data.length > 0 ? (
              <div></div>
            )
            :
            (
                <div> {/*<p>No records to display</p>*/}</div>
            )}
          </div>
      </div>
      <FamilyAddForm isOpen={showForm} 
                    onClose={closeForm}
                    employeeId={employeeId}
                    addEmployeesFamily={addEmployeesFamily}/>
      <FamilyEditForm isOpen={showEditForm} 
                    onClose={closeEditForm}
                    editData={editData}
                    employeeId={employeeId}
                    addEmployeesFamily={updateData}/>
    </div>
  )
}
function BenefitsTab({viewedData, isEditMode}){
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
      if (showRequestMessage) {
          const timeoutId = setTimeout(() => {
              setShowRequestMessage(false);
          }, 5000);

          return () => clearTimeout(timeoutId);
      }
      
  }, [showRequestMessage]);
  function GenerateMessage({form, message, isSuccess}){
      return (
          <>
              <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                  {form && (
                  <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                      <div className='column'>
                          {isSuccess ?
                              <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                  <CheckCircleIcon/>
                                  <span >{"SUCCESS MESSAGE"}</span>
                              </div>
                              :
                              <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                  <ErrorIcon/>
                                  <span>{"ERROR MESSAGE"}</span>
                              </div>
                          }
                          <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                      </div>
                  </div>
              )}
              </div>
          </>
      );
  }
  //Request Messages -end

  var header = [
    "Benefit",
    "Benefit Type",
    "Amount",
    "",
  ]
  var accessor = [
    "benefitName",
    "benefitType",
    "amount",
    "manage",
  ]

  const [benefitId, setBenefitId] = useState("");
  const [isActive, setIsActive] = useState(false);

  const resetLocalVariable = () => {
    setBenefitId("")
    setIsActive(false)
  }

  const fetchData = useCallback(async () => {
    const apiUrl = domain + `/api/Beneficiary/employee/${viewedData.id}`;

    try {
        setLoading(true);
        const response = await axios.get(apiUrl , {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json' // You can include other headers if needed
    }})
        setData(response?.data); // Set the response data to the state
    } catch (error) {
        console.error('Error fetching data:', error);
    } finally {
        setLoading(false); // Set loading state to false after data fetching is complete
    }
  }, [viewedData]);

  const [selectedData, setSelectedData] = useState(null);
  const [showAddForm, setShowAddForm] = useState(false);
  const openAddForm = () => {
    setShowAddForm(true)
  }
  const closeAddForm = () => {
    setShowAddForm(false)
    resetLocalVariable()
  }
  const handleSubmitBeneficiary = async (event) => {
    const apiUrlBeneficiary =  domain + "/api/Beneficiary";
    event.preventDefault();

    const data = {
        employeePersonalInformationId: viewedData.id,
        benefitId: benefitId,
        isActive: isActive
    };

    try {
      setLoading(true);
      await axios.post(apiUrlBeneficiary, data, {
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
          }
      });

      await fetchData();

      console.log('Data added successfully');
      setShowRequestMessage(true);
      setIsSuccess(true);
      
      // Reload table data and reset form fields
      setBenefitId("");
      setIsActive(false);
  } catch (error) {
      setLoading(false);
      console.error('There was a problem adding data:', error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setRequestMessage(errorMessage);
  } finally {
      setLoading(false);
  }
  };

  const [showEditForm, setShowEditForm] = useState(false);
  const openEditForm = () => {
    setShowEditForm(true)
  }
  const closeEditForm = () => {
    setShowEditForm(false)
    resetLocalVariable()
  }
  const handleUpdateBeneficiary = async (event) => {
    const apiUrlBeneficiary =  domain + "/api/Beneficiary";
    event.preventDefault();

    const data = {
        employeePersonalInformationId: viewedData.id,
        benefitId: benefitId,
        isActive: isActive
    };

    try {
        setLoading(true);
        await axios.put(apiUrlBeneficiary + `/${selectedData.id}`, data, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });

        await fetchData();

        console.log('Data updated successfully');
        setShowRequestMessage(true);
        setIsSuccess(true);
    } catch (error) {
        setLoading(false);
        console.error('There was a problem updating data:', error);
        setShowRequestMessage(true);
        setIsSuccess(false);
        const errorMessage = JSON.parse(error.response.request.responseText).message;
        setRequestMessage(errorMessage);
    } finally {
        setLoading(false);
    }
  };

  const [showDeleteForm, setShowDeleteForm] = useState(false);
  const openDeleteForm = () => {
    setShowDeleteForm(true)
  }
  const closeDeleteForm = () => {
    setShowDeleteForm(false)
    resetLocalVariable()
  }
  const handleDelete = async () => {
    const apiUrlBeneficiary =  domain + "/api/Beneficiary";
    try {
        setLoading(true);
        await axios.delete(apiUrlBeneficiary + `/${selectedData.id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        await fetchData();

        console.log('Deleted successfully');
        setShowRequestMessage(true);
        setIsSuccess(true);
    } catch (error) {
        setLoading(false);
        console.error('There was a problem deleting employee:', error);
        setShowRequestMessage(true);
        setIsSuccess(false);
        const errorMessage = JSON.parse(error.response.request.responseText).message;
        setRequestMessage(errorMessage);
    } finally {
        setLoading(false);
    }
  };

  const editHandleClick = (data) => {
    setSelectedData(data);
    setBenefitId(data.benefitId);
    setIsActive(data.isActive);
    openEditForm()
  }
  const deleteHandleClick = (data) => {
    setSelectedData(data);
    openDeleteForm();
  }

  useEffect(() => {
    fetchData();
  }, [fetchData])

  return (
    <>
      <div className="family-tab-top"  style={{display:isEditMode? "flex" : "none", justifyContent:"start"}}>
        {CreateButton("addEmployee-family-add", "add row", ()=>openAddForm(), "ADD", GroupAddIcon)}
      </div>
      <div className="family-tab-body">
        <div className="employeesTab-table container">
          <CreateTable
            dataList={data}
            dataHeader={header}
            dataAccessor={accessor}
            editHandleClick={editHandleClick}
            deleteHandleClick={deleteHandleClick}
            isEditMode={isEditMode}
          />
          {data?.length > 0 ? (
            <div></div>
          )
          :
          (
              <div> {/*<p>No records to display</p>*/}</div>
          )}
        </div>
      </div>

      <AddEditFormBeneficiary  isOpen={showAddForm} 
        onClose={closeAddForm}
        benefitId={benefitId}
        setBenefitId={setBenefitId}

        isActive={isActive}
        setIsActive={setIsActive}

        handleSubmit={handleSubmitBeneficiary}
        modalName = "Add Benefit"
      ></AddEditFormBeneficiary>

      <AddEditFormBeneficiary  isOpen={showEditForm} 
        onClose={closeEditForm}
        benefitId={benefitId}
        setBenefitId={setBenefitId}

        isActive={isActive}
        setIsActive={setIsActive}

        handleSubmit={handleUpdateBeneficiary}
        modalName = "Update Benefit"
      ></AddEditFormBeneficiary>

      <DeleteForm  isOpen={showDeleteForm} 
              onClose={closeDeleteForm}
              handleDelete={handleDelete}
      >
      </DeleteForm>
      
      <GenerateMessage form={showRequestMessage}
              message={isSuccess ? "Request Success!" : requestMessage}
              isSuccess={isSuccess}
      > 
      </GenerateMessage>

      {loading ? (
        <div
            style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            zIndex: "2000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            backgroundColor: "#ffffff59",
            }}
        >
            <img src={loadingSpinner} alt="Loading..." />
        </div>
        ) : (
            <></>
            )
        }
    </>
  )
}
function RequirementsTab({viewedData, isEditMode}){
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
      if (showRequestMessage) {
          const timeoutId = setTimeout(() => {
              setShowRequestMessage(false);
          }, 5000);

          return () => clearTimeout(timeoutId);
      }
      
  }, [showRequestMessage]);
  function GenerateMessage({form, message, isSuccess}){
      return (
          <>
              <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                  {form && (
                  <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                      <div className='column'>
                          {isSuccess ?
                              <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                  <CheckCircleIcon/>
                                  <span >{"SUCCESS MESSAGE"}</span>
                              </div>
                              :
                              <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                  <ErrorIcon/>
                                  <span>{"ERROR MESSAGE"}</span>
                              </div>
                          }
                          <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                      </div>
                  </div>
              )}
              </div>
          </>
      );
  }
  //Request Messages -end

  const header = [
    'Requirement', 
    'File', 
    'Has Completed?', 
    'Is Active?', 
    ''
  ]
  const accessor = [
    'onBoardingRequirementsDescription', 
    'file', 
    'hasCompleted', 
    'isActive', 
    'manage'
  ]

  const [onBoardingRequirements, setOnBoardingRequirements] = useState(null);
  const [file, setFile] = useState(null);
  const [hasCompleted, setHasCompleted] = useState(false);
  const [isActive, setIsActive] = useState(false);

  const resetLocalVariable = () => {
    setOnBoardingRequirements(null)
    setFile(null)
    setHasCompleted(false)
    setIsActive(false)
  }

  const fetchData = useCallback(async () => {
    const apiUrl = domain + `/api/OnBoarding/employee/${viewedData.employeeId}`;

    try {
        setLoading(true);
        const response = await axios.get(apiUrl , {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json' // You can include other headers if needed
    }})
        setData(response?.data); // Set the response data to the state
    } catch (error) {
        console.error('Error fetching data:', error);
    } finally {
        setLoading(false); // Set loading state to false after data fetching is complete
    }
  }, [viewedData]);

  const [selectedData, setSelectedData] = useState(null);
  const [showAddForm, setShowAddForm] = useState(false);
  const openAddForm = () => {
    setShowAddForm(true)
  }
  const closeAddForm = () => {
    setShowAddForm(false)
    resetLocalVariable()
  }
  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(",")[1]); // get Base64 without prefix
      reader.onerror = (error) => reject(error);
    });
  };
  const handleAdd = async () => {
    const apiUrl = domain + "/api/OnBoarding/requirement";
    const base64File = file ? await fileToBase64(file) : null;

    const _data = {
        onBoardingId: data.id,
        onBoardingRequirementsId: onBoardingRequirements.id,
        file: base64File, // backend must decode this into byte[]
        fileName: file?.name ?? null,
        hasCompleted: hasCompleted,
        isActive: isActive,
    };

    try {
      setLoading(true);
      await axios.post(apiUrl, _data, {
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
          }
      });

      await fetchData();

      console.log('Data added successfully');
      setShowRequestMessage(true);
      setIsSuccess(true);
  } catch (error) {
      setLoading(false);
      console.error('There was a problem adding data:', error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setRequestMessage(errorMessage);
  } finally {
      setLoading(false);
  }
  };

  const [showEditForm, setShowEditForm] = useState(false);
  const openEditForm = () => {
    setShowEditForm(true)
  }
  const closeEditForm = () => {
    setShowEditForm(false)
    resetLocalVariable()
  }
  const handleUpdate = async (event) => {
    const apiUrl = domain + "/api/OnBoarding/requirement";
    const base64File = file ? await fileToBase64(file) : null;

    const _data = {
      onBoardingId: data.id,
      onBoardingRequirementsId: onBoardingRequirements.id,
      file: base64File, // backend must decode this into byte[]
      fileName: file?.name ?? null,
      hasCompleted: hasCompleted,
      isActive: isActive,
    };

    try {
        setLoading(true);
        await axios.put(apiUrl + `/${selectedData.id}`, _data, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });

        await fetchData();

        console.log('Data updated successfully');
        setShowRequestMessage(true);
        setIsSuccess(true);
    } catch (error) {
        setLoading(false);
        console.error('There was a problem updating data:', error);
        setShowRequestMessage(true);
        setIsSuccess(false);
        const errorMessage = JSON.parse(error.response.request.responseText).message;
        setRequestMessage(errorMessage);
    } finally {
        setLoading(false);
    }
  };

  const editHandleClick = (data) => {
    console.log(data)
    setSelectedData(data);
    const reqData = {
      id: data.onBoardingRequirementsId,
      description: data.onBoardingRequirementsDescription
    }

    // ✅ If there's a file from backend, reconstruct it
    if (data.file) {
      const binaryData = atob(data.file); // decode base64

      const arrayBuffer = new ArrayBuffer(binaryData.length);
      const uint8Array = new Uint8Array(arrayBuffer);

      for (let i = 0; i < binaryData.length; i++) {
        uint8Array[i] = binaryData.charCodeAt(i);
      }

      // use mimeType + fileName if you store them in DB
      const mimeType = data.mimeType || "application/octet-stream";
      const fileName = data.fileName;

      const blob = new Blob([uint8Array], { type: mimeType });
      const file = new File([blob], fileName, { type: mimeType });

      setFile(file); // ✅ now your state is a real File object
    } else {
      setFile(null);
    }

    setOnBoardingRequirements(reqData)
    setHasCompleted(data.hasCompleted)
    setIsActive(data.isActive)
    openEditForm()
  }
  const downloadHandleClick = async (data) => {
    try {
      setLoading(true); // ✅ start loading

      if (data.file) {
        const binaryData = atob(data.file); // decode base64

        const arrayBuffer = new ArrayBuffer(binaryData.length);
        const uint8Array = new Uint8Array(arrayBuffer);

        for (let i = 0; i < binaryData.length; i++) {
          uint8Array[i] = binaryData.charCodeAt(i);
        }

        // use mimeType + fileName if you store them in DB
        const mimeType = data.mimeType || "application/octet-stream";
        const fileName = data.fileName || "download";

        const blob = new Blob([uint8Array], { type: mimeType });
        const file = new File([blob], fileName, { type: mimeType });

        const url = URL.createObjectURL(file);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        link.click();

        URL.revokeObjectURL(url);
      } else {
        console.warn("No file data found.");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
    } finally {
      setLoading(false); // ✅ always end loading
    }
  };

  useEffect(() => {
    fetchData();
  }, [fetchData])

  return (
    <>
      <div className="family-tab-top"  style={{display:isEditMode? "flex" : "none", justifyContent:"start"}}>
        {CreateButton("addEmployee-family-add", "add row", ()=>openAddForm(), "ADD", GroupAddIcon)}
      </div>
      <div className="family-tab-body">
        <div className="employeesTab-table container">
          <CreateTable2
            dataList={data?.requirements}
            dataHeader={header}
            dataAccessor={accessor}
            editHandleClick={editHandleClick}
            downloadHandleClick={downloadHandleClick}
            isEditMode={isEditMode}
          />
          {data?.requirements?.length > 0 ? (
            <div></div>
          )
          :
          (
              <div> {/*<p>No records to display</p>*/}</div>
          )}
        </div>
      </div>

      <AddUpdateRequirementModal 
        visible={showAddForm}
        onClose={closeAddForm}
        onSave={handleAdd}
        modalName={"Add Data"}

        data={data}
        onBoardingRequirements={onBoardingRequirements} setOnBoardingRequirements={setOnBoardingRequirements}
        file={file} setFile={setFile}
        hasCompleted={hasCompleted} setHasCompleted={setHasCompleted}
        isActive={isActive} setIsActive={setIsActive}
      />

      <AddUpdateRequirementModal 
        visible={showEditForm}
        onClose={closeEditForm}
        onSave={handleUpdate}
        modalName={"Update Data"}

        data={data}
        onBoardingRequirements={onBoardingRequirements} setOnBoardingRequirements={setOnBoardingRequirements}
        file={file} setFile={setFile}
        hasCompleted={hasCompleted} setHasCompleted={setHasCompleted}
        isActive={isActive} setIsActive={setIsActive}
      />
      
      <GenerateMessage form={showRequestMessage}
              message={isSuccess ? "Request Success!" : requestMessage}
              isSuccess={isSuccess}
      > 
      </GenerateMessage>

      {loading ? (
        <div
            style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            zIndex: "5000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            backgroundColor: "#ffffff59",
            }}
        >
            <img src={loadingSpinner} alt="Loading..." />
        </div>
        ) : (
            <></>
            )
        }
    </>
  )
}
function GenerateIdTab({ viewedData }) {
  const [isGenerate, setIsGenerate] = useState(false);
  const idContainerRef_front = useRef(null);
  const canvasRef_front = useRef(null);
  const idContainerRef_back = useRef(null);
  const canvasRef_back = useRef(null);

  const [loading, setLoading] = useState(false);
  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
      if (showRequestMessage) {
          const timeoutId = setTimeout(() => {
              setShowRequestMessage(false);
          }, 5000);

          return () => clearTimeout(timeoutId);
      }
      
  }, [showRequestMessage]);
  function GenerateMessage({form, message, isSuccess}){
      return (
          <>
              <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                  {form && (
                  <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                      <div className='column'>
                          {isSuccess ?
                              <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                  <CheckCircleIcon/>
                                  <span >{"SUCCESS MESSAGE"}</span>
                              </div>
                              :
                              <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                  <ErrorIcon/>
                                  <span>{"ERROR MESSAGE"}</span>
                              </div>
                          }
                          <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                      </div>
                  </div>
              )}
              </div>
          </>
      );
  }
  //Request Messages -end


  const generateId = () => {
    setIsGenerate(true);
  };

  const [qrVisible, setQrVisible] = useState(false);
  const generateQRCode = () => {
    setQrVisible(true); // show the QR code when clicked
  }
  const closeQRCodeForm = () => {
    setQrVisible(false); // show the QR code when clicked
  }

  const qrValue = JSON.stringify({
    id: viewedData?.id,
    employeeId: viewedData?.employeeId,
  });

  // const [generatePrint, setGeneratePrint] = useState(false);

  /* const downloadImage = () => {
    const canvas_front = canvasRef_front.current;
    const canvas_back = canvasRef_back.current;
  
    // Create a link for the front image
    const linkFront = document.createElement('a');
    linkFront.download = `${viewedData.lastName.toLowerCase()}_${viewedData.firstName.toLowerCase()}_id_front.jpg`;  // Change file extension to .jpg
    linkFront.href = canvas_front.toDataURL('image/jpeg');  // Change MIME type to 'image/jpeg'
    linkFront.click();
  
    // Create a link for the back image
    const linkBack = document.createElement('a');
    linkBack.download = `${viewedData.lastName.toLowerCase()}_${viewedData.firstName.toLowerCase()}_id_back.jpg`;  // Change file extension to .jpg
    linkBack.href = canvas_back.toDataURL('image/jpeg');  // Change MIME type to 'image/jpeg'
    linkBack.click();
  }; */

  const downloadImage = async () => {
    const canvas_front = canvasRef_front.current;
    const canvas_back = canvasRef_back.current;

    // Convert canvas to Blob for the front image
    const frontBlob = await new Promise((resolve) => canvas_front.toBlob(resolve, 'image/jpeg'));

    // Convert canvas to Blob for the back image
    const backBlob = await new Promise((resolve) => canvas_back.toBlob(resolve, 'image/jpeg'));

    // Create form data
    const formData = new FormData();
    formData.append(
        'frontImage',
        frontBlob,
        `${viewedData.lastName.toLowerCase()}_${viewedData.firstName.toLowerCase()}_id_front.jpg`
    );
    formData.append(
        'backImage',
        backBlob,
        `${viewedData.lastName.toLowerCase()}_${viewedData.firstName.toLowerCase()}_id_back.jpg`
    );

    try {
        setLoading(true);
        // Send the images to the backend via POST request
        const response = await axios.post('http://161.49.93.114:8081/api/PrintId/upload-image', formData, {
        // const response = await axios.post('http://192.168.10.157:8082/api/PrintId/upload-image', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });

        if (response.status !== 200) {
            throw new Error('Error uploading images');
        }

        console.log('Images uploaded successfully');

        setRequestMessage("Print starting....");
        setShowRequestMessage(true);
        setIsSuccess(true);

        // setGeneratePrint(true);
    } catch (error) {
        console.error('Error uploading images:', error);

        setLoading(false);
        setShowRequestMessage(true);
        setIsSuccess(false);
        const errorMessage = JSON.parse(error.response.request.responseText).message;
        setRequestMessage(errorMessage);
    }
    finally {
      setLoading(false);
    }
  };

  /* useEffect(() => {

    if (generatePrint) {

      setGeneratePrint(false);  // Reset the flag
    }
  }, [generatePrint]); */


  const generateFullName = (firstName, middleName, lastName) => {
    // Capitalize the first letter of each name and make the rest uppercase
    const capitalize = (name) => name.toUpperCase();
    
    // Check if the middle name is valid
    if (middleName && middleName.toLowerCase() !== 'none') {
        // Abbreviate the middle name to its initial
        const abbreviatedMiddleName = middleName.charAt(0).toUpperCase() + '.';
        // Format the full name with the middle initial and convert to uppercase
        return `${capitalize(firstName)} ${abbreviatedMiddleName} ${capitalize(lastName)}`;
    } else {
        // If middle name is empty or 'none', format the full name without the middle name and convert to uppercase
        return `${capitalize(firstName)} ${capitalize(lastName)}`;
    }
  };

  const capitalizedName = (name) => {
    return name.toUpperCase();
  };

  const FrontIdGenerator = ({ template, photo, signature }) => {
    useEffect(() => {
      const canvas = canvasRef_front.current;
      const idContainer = idContainerRef_front.current;
      
      // Set canvas size to match id-container size
      canvas.width = idContainer.offsetWidth;
      canvas.height = idContainer.offsetHeight;

      const context = canvas.getContext('2d');
      const _template = new Image();
      const _photo = new Image();
      const _signature = new Image();

      _template.src = template;
      _photo.src = photo;
      _signature.src = signature;

      // Helper function to load an image and return a promise
      const loadImage = (img) => {
        return new Promise((resolve, reject) => {
          img.onload = () => resolve();
          img.onerror = () => reject(new Error('Image failed to load'));
        });
      };

      // Wait for both images to load before drawing them
      Promise.all([loadImage(_template), loadImage(_photo), loadImage(_signature)])
      .then(() => {
        // Draw first image
        context.drawImage(_template, 0, 0, canvas.width, canvas.height);
        
        // Draw second image on top of the first one
        context.drawImage(_photo, 100, 135, 175, 175);
        // Draw the border
        context.strokeStyle = 'black';
        context.lineWidth = 1;
        context.strokeRect(100, 135, 175, 175);
        
        // Optionally, add text on top
        context.font = 'bold 30px Arial';
        context.fillStyle = 'white';
        context.textAlign = 'center';
        context.fillText(`"${viewedData.nickName ? capitalizedName(viewedData.nickName) : capitalizedName(viewedData.firstName)}"`, canvas.width / 2, 460);

        context.font = 'bold 16px Arial';
        context.fillStyle = 'white';
        context.textAlign = 'center';
        context.fillText(`${generateFullName(viewedData.firstName, viewedData.middleName, viewedData.lastName)}`, canvas.width / 2, 490);

        context.font = 'normal 12px Arial';
        context.fillStyle = 'white';
        context.textAlign = 'center';
        context.fillText(`EMPLOYEE NO: ${viewedData.employeeId}`, canvas.width / 2, 510);

        context.drawImage(_signature, 100, 530, 150, 50);
      })
      .catch(error => {
        console.error('Failed to load images:', error);
      });
    }, [template, photo, signature]);

    return (
      <div>
        <canvas ref={canvasRef_front} style={{ border: '1px solid black', width: '100%', height: '100%' }} />
      </div>
    );
  };

  const BackIdGenerator = ({ template, signature }) => {
    useEffect(() => {
      const canvas = canvasRef_back.current;
      const idContainer = idContainerRef_back.current;
      
      // Set canvas size to match id-container size
      canvas.width = idContainer.offsetWidth;
      canvas.height = idContainer.offsetHeight;

      const context = canvas.getContext('2d');
      const _template = new Image();
      const _signature = new Image();

      _template.src = template;
      _signature.src = signature;

      // Helper function to load an image and return a promise
      const loadImage = (img) => {
        return new Promise((resolve, reject) => {
          img.onload = () => resolve();
          img.onerror = () => reject(new Error('Image failed to load'));
        });
      };

      // Wait for both images to load before drawing them
      Promise.all([loadImage(_template), loadImage(_signature)])
      .then(() => {
        context.drawImage(_template, 0, 0, canvas.width, canvas.height);

        if(viewedData.employeeAccountInformation){
          context.font = 'normal 16px Arial';
          context.fillStyle = '#f34708';
          context.textAlign = 'center';
          context.fillText(`${viewedData.employeeAccountInformation.sss ? viewedData.employeeAccountInformation.sss : ""}`, 265, 45);
          context.fillText(`${viewedData.employeeAccountInformation.tin ? viewedData.employeeAccountInformation.tin : ""}`, 265, 69);
          context.fillText(`${viewedData.employeeAccountInformation.philhealth ? viewedData.employeeAccountInformation.philhealth : ""}`, 265, 91);
          context.fillText(`${viewedData.employeeAccountInformation.pagibig ? viewedData.employeeAccountInformation.pagibig : ""}`, 265, 113);
        }
        
        context.drawImage(_signature, 100, 250, 150, 50);

        if(viewedData.employeeEmergencyContacts[0]){
          context.font = 'normal 16px Arial';
          context.fillStyle = 'white';
          context.textAlign = 'left';
          context.fillText(`${viewedData.employeeEmergencyContacts[0].name}`, 175, 435);
          context.fillText(`${viewedData.employeeEmergencyContacts[0].relationship}`, 175, 455);
          
          //Address
          // Text wrapping settings
          const maxWidth = 200; // Maximum width of text lines
          const text = viewedData.employeeEmergencyContacts[0].address;
          const words = text.split(' ');
          let line = '';
          let lines = [];

          // Wrap text into lines
          for (let i = 0; i < words.length; i++) {
            const testLine = line + words[i] + ' ';
            const metrics = context.measureText(testLine);
            const testWidth = metrics.width;

            if (testWidth > maxWidth && i > 0) {
              lines.push(line);
              line = words[i] + ' ';
            } else {
              line = testLine;
            }
          }
          lines.push(line); // Push the last line

          // Draw each line
          const startX = 175; // X position
          let startY = 475; // Initial Y position
          const lineHeight = 20; // Line height (adjust if necessary)

          for (let i = 0; i < lines.length; i++) {
            context.fillText(lines[i], startX, startY);
            startY += lineHeight; // Move down for the next line
          }
          
          context.fillText(`${viewedData.employeeEmergencyContacts[0].contactNumber}`, 175, 515);
        }
      })
      .catch(error => {
        console.error('Failed to load images:', error);
      });
    }, [template, signature]);

    return (
      <div>
        <canvas ref={canvasRef_back} style={{ border: '1px solid black', width: '100%', height: '100%' }} />
      </div>
    );
  };

  return (
    <>
      <div className="family-tab">
        <div className="family-tab-top row">
          <div className='row' style={{gap: "5px"}}>
            {CreateButton("addEmployee-family-add", "generate-submit row", () => generateQRCode(), "GENERATE QR", QrCodeIcon)}
            {CreateButton("addEmployee-family-add", "generate-submit row", () => generateId(), "GENERATE ID", SyncIcon)}
          </div>
          <div style={{marginLeft: "5px"}}>
            { isGenerate && CreateButton("addEmployee-family-add", "print-button row", () => downloadImage(), "PRINT", LocalPrintshopIcon)}
          </div>
    
        </div>
        <div className="family-tab-body">
          <div className="generate-id-body-container row centeredStyle" style={{ padding: 20, justifyContent: "space-between" }}>
            <div className="id-container centeredStyle" ref={idContainerRef_front}>
              {!isGenerate ? (
                "Front"
              ) : (
                <FrontIdGenerator template={"images/id_front.jpg"} photo={viewedData.photo ? `data:image/png;base64,${viewedData.photo}` : "images/sample.jpg"} signature={"images/signature.png"}/>
              )}
            </div>
            <div className="id-container centeredStyle" ref={idContainerRef_back}>
              {!isGenerate ? 
                "Back" 
                : 
                <BackIdGenerator template={"images/id_back.jpg"} signature={"images/signature.png"}/>
              }
            </div>
          </div>
        </div>
        <GenerateMessage form={showRequestMessage}
                message={requestMessage}
                isSuccess={isSuccess}
        > 
        </GenerateMessage>
        {loading ? (
            <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3100"}}>
                <img src={loadingSpinner} alt="Loading..." />
            </div>
        ) : (
                <></>
            )
        }
      </div>

      {qrVisible && (
        <QRCodeForm isOpen={qrVisible} qrValue={qrValue} onClose={closeQRCodeForm}/>
      )}
    </>
  );
}
function CompanyTypeIdSelect(companyId, setCompanyId, isEditMode){
  const [isSelected, setIsSelected] = useState(false);
  
  const handleSelectChange = (event) => {
      setIsSelected(true);
      setCompanyId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
      const apiUrl =  domain + "/api/Company/active";

      await axios.get(apiUrl , {
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json' // You can include other headers if needed
      }})
      .then(response => {
        response.data.sort((a, b) => a.name.localeCompare(b.name));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
          console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
      fetchData();
      if(companyId !== "" && companyId !== 0 && companyId !== null && companyId !== undefined){
          setIsSelected(true);
      } else {
          setIsSelected(false);
      }
  }, [companyId]);

  useEffect(() => {
    if(companyId){
      if (!data || data.length === 0) {
        return;
      }

      const foundData = data.find(i => i.id.toString() === companyId.toString());
  
      if(!foundData){
        setCompanyId("")
      }
    }
    
  }, [data, companyId, setCompanyId]);

  return (
      <div>
          <select id="employee-select-PagibigReport" disabled={!isEditMode} value={companyId || ''} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
          <option value="">None</option>
          {data.map((companyId) => ( 
              SetCompanyType(companyId)
          ))}
          </select>
      </div>
  );
};
function SetCompanyType(companyId){
  return(
      <option value={companyId.id}>{
        companyId.name}
      </option>
  )
  
}
function Gender(gender, setGender, isEditMode){
  const [isSelected, setIsSelected] = useState(false);
  
  const handleSelectChange = (event) => {
    setGender(event.target.value);
    setIsSelected(true);
  };

  useEffect(() => {
    if(gender !== "" && gender !== 0 && gender !== null && gender !== undefined){
        setIsSelected(true);
    } else {
        setIsSelected(false);
    }
  }, [gender]);

  return (
      <div>
          <select value={gender || ''} onChange={handleSelectChange} disabled={!isEditMode} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
          <option value="">None</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
          </select>
      </div>
  );
}
function Gender2({id, value, onChange}){
  const [isSelected, setIsSelected] = useState(false);
  
  const handleSelectChange = (event) => {
    onChange(event.target.value);
    setIsSelected(true);
  };

  useEffect(() => {
    if(value !== "" && value !== 0 && value !== null && value !== undefined){
        setIsSelected(true);
    } else {
        setIsSelected(false);
    }
  }, [value]);
  
  return (
      <div>
          <select id={"AddEmployee-" + id} value={value || ''} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
          <option value="">None</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
          </select>
      </div>
  );
}
function CivilStatus(civilStatus, setCivilStatus, isEditMode){
  const [isSelected, setIsSelected] = useState(false);
  
  const handleSelectChange = (event) => {
    setCivilStatus(event.target.value);
    setIsSelected(true);
  };

  useEffect(() => {
    if(civilStatus !== "" && civilStatus !== 0 && civilStatus !== null && civilStatus !== undefined){
        setIsSelected(true);
    } else {
        setIsSelected(false);
    }
  }, [civilStatus]);

  return (
      <div>
          <select value={civilStatus || ''} disabled={!isEditMode} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
          <option value="">None</option>
          <option value="Single">Single</option>
          <option value="Married">Married</option>
          </select>
      </div>
  );
}
function CivilStatus2({id, value, onChange}){
  const [isSelected, setIsSelected] = useState(false);
  
  const handleSelectChange = (event) => {
    onChange(event.target.value);
    setIsSelected(true);
  };

  useEffect(() => {
    if(value !== "" && value !== 0 && value !== null && value !== undefined){
        setIsSelected(true);
    } else {
        setIsSelected(false);
    }
  }, [value]);

  return (
      <div>
          <select id={"AddEmployee-" + id} value={value || ''} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
          <option value="">None</option>
          <option value="Single">Single</option>
          <option value="Married">Married</option>
          </select>
      </div>
  );
}
function SalaryType({salaryType, setSalaryType, isEditMode}){
  const [isSelected, setIsSelected] = useState(false);
  
  const handleSelectChange = (event) => {
    setSalaryType(event.target.value);
    setIsSelected(true);
  };

  useEffect(() => {
    if(salaryType !== "" && salaryType !== 0 && salaryType !== null && salaryType !== undefined){
        setIsSelected(true);
    } else {
        setIsSelected(false);
    }
  }, [salaryType]);

  return (
      <div>
          <select disabled={!isEditMode} value={salaryType || ''} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
          <option value="">None</option>
          <option value="Daily">Daily</option>
          <option value="Monthly">Monthly</option>
          <option value="QoutaBased">Qouta-Based</option>
          <option value="PositionDesignation">Position - Designation</option>
          </select>
      </div>
  );
}
function EmployeeStatus({employeeStatus, setEmployeeStatus, isEditMode}){
  const [isSelected, setIsSelected] = useState(false);
  
  const handleSelectChange = (event) => {
      setIsSelected(true);
      setEmployeeStatus(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
      const apiUrl =  domain + "/api/EmployeeStatusMaintenance/active";

      await axios.get(apiUrl , {
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json' // You can include other headers if needed
      }})
      .then(response => {
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
          console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
      fetchData();
      if(employeeStatus !== "" && employeeStatus !== 0 && employeeStatus !== null && employeeStatus !== undefined){
          setIsSelected(true);
      } else {
          setIsSelected(false);
      }
  }, [employeeStatus]);

  useEffect(() => {
    if(employeeStatus){
      if (!data || data.length === 0) {
        return;
      }
  
      const foundData = data.find(i => i.description === employeeStatus);
  
      if(!foundData){
        setEmployeeStatus("")
      }
    }
    
  }, [data, employeeStatus, setEmployeeStatus]);

  return (
      <div>
          <select id="employee-select-PagibigReport" disabled={!isEditMode} value={employeeStatus || ''} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
          <option value="">None</option>
          {data.map((data) => ( 
              SetEmployeeStatusType(data)
          ))}
          </select>
      </div>
  );
}
function SetEmployeeStatusType(data){
  return(
      <option value={data.description}>{
        data.description}
      </option>
  )
  
}
function Age2({id, value, onChange}){
  const [age, setAge] = useState("");

  const handleAgeChange = (event) => {
      const value = parseInt(event.target.value);
      onChange(value);
      setAge(isNaN(value) ? '' : value); // Ensure value is a number or empty string
  };

  return (
      <div>
          <input
              type="number"
              id={"AddEmployee-" + id}
              name="age"
              value={age}
              placeholder="Age"
              onChange={handleAgeChange}
              style={{
                  width: "90%",
                  height: "30px",
                  borderRadius: "3px",
                  border: "1px solid #80808080",
                  color: "rgb(104, 104, 104)"
              }}
          />
      </div>
  );
}
function LocationIdSelect(locationId, setLocationId, isEditMode){
  const [isSelected, setIsSelected] = useState(false);
  
  const handleSelectChange = (event) => {
      setIsSelected(true);
      setLocationId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
      const apiUrl =  domain + "/api/Location/active";

      await axios.get(apiUrl , {
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json' // You can include other headers if needed
      }})
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
          console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
      fetchData();
      if(locationId !== "" && locationId !== 0 && locationId !== null  && locationId !== undefined){
          setIsSelected(true);
      } else {
          setIsSelected(false);
      }
  }, [locationId]);

  useEffect(() => {
    if(locationId){
      if (!data || data.length === 0) {
        return;
      }
  
      const foundData = data.find(i => i.id.toString() === locationId.toString());
  
      if(!foundData){
        setLocationId("")
      }
    }
    
  }, [data, locationId, setLocationId]);

  return (
      <div>
          <select id="employee-select-PagibigReport" disabled={!isEditMode} value={locationId || ''} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
          <option value="">None</option>
          {data.map((locationId) => ( 
              SetLocationId(locationId)
          ))}
          </select>
      </div>
  );
};
function SetLocationId(locationId){
  return(
      <option value={locationId.id}>{
        locationId.description}
      </option>
  )
  
}
function DateInput(date, setDate, isEditMode) {
  const [isSelected, setIsSelected] = useState(false);

  const handleDateTimeChange = (event) => {
    setDate(event.target.value);
    setIsSelected(true);
  };

  useEffect(() => {
    if(date !== undefined && date !== "" && date !== null){
        setIsSelected(true);
    } else {
        setIsSelected(false);
    }
  }, [date]);

  let formattedDate = "";

  if(date){
    formattedDate = date.split('T')[0];
  }

  return (
      <div>
          <input
          readOnly={!isEditMode}
          type="date"
          name="datetime"
          value={formattedDate || ''}
          onChange={handleDateTimeChange}
          style={{width:"90%",
              height:"30px", 
              borderRadius:"3px", 
              border:"1px solid #80808080",
              color: isSelected? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
              fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
          }}
          />
      </div>
  );
}
function DateInput2({id, value, onChange}) {
  const [isSelected, setIsSelected] = useState(false);

  const handleDateTimeChange = (event) => {
      onChange(event.target.value);
      setIsSelected(true);
  };

  useEffect(() => {
    if(value !== undefined && value !== "" && value !== null){
        setIsSelected(true);
    } else {
        setIsSelected(false);
    }
}, [value]);

let formattedDate = "";
  
  if(value){
    formattedDate = value.split('T')[0];
  }

  return (
      <div>
          <input
          type="date"
          id={"AddEmployee-" + id}
          name="datetime"
          value={formattedDate || ''}
          onChange={handleDateTimeChange}
          style={{width:"90%",
              height:"30px", 
              borderRadius:"3px", 
              border:"1px solid #80808080",
              color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
              fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
          }}
          />
      </div>
  );
}
function EmploymentId(employmentId, setEmploymentId, isEditMode){
  const [isSelected, setIsSelected] = useState(false);
  
  const handleSelectChange = (event) => {
      setIsSelected(true);
      setEmploymentId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
      const apiUrl =  domain + "/api/Employment/active";

      await axios.get(apiUrl , {
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json' // You can include other headers if needed
      }})
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
          console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
      fetchData();
      if(employmentId !== "" && employmentId !== 0 && employmentId !== null && employmentId !== undefined){
          setIsSelected(true);
      } else {
          setIsSelected(false);
      }
  }, [employmentId]);

  useEffect(() => {
    if(employmentId){
      if (!data || data.length === 0) {
        return;
      }
  
      const foundData = data.find(i => i.id.toString() === employmentId.toString());
  
      if(!foundData){
        setEmploymentId("")
      }
    }
    
  }, [data, employmentId, setEmploymentId]);

  return (
      <div>
          <select id="employee-select-PagibigReport" disabled={!isEditMode} value={employmentId || ''} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
          <option value="">None</option>
          {data.map((employmentId) => ( 
              SetEmploymentId(employmentId)
          ))}
          </select>
      </div>
  );
};
function SetEmploymentId(employmentId){
  return(
      <option value={employmentId.id}>{
        employmentId.description}
      </option>
  )
  
}
function DepartmentIdSelect(departmentId, setDepartmentId, isEditMode){
  const [isSelected, setIsSelected] = useState(false);
  
  const handleSelectChange = (event) => {
      setIsSelected(true);
      setDepartmentId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
      const apiUrl =  domain + "/api/Department/active";

      await axios.get(apiUrl , {
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json' // You can include other headers if needed
      }})
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
          console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
      fetchData();
      if(departmentId !== "" && departmentId !== 0 && departmentId !== null && departmentId !== undefined){
          setIsSelected(true);
      } else {
          setIsSelected(false);
      }
  }, [departmentId]);

  useEffect(() => {
    if(departmentId){
      if (!data || data.length === 0) {
        return;
      }
  
      const foundData = data.find(i => i.id.toString() === departmentId.toString());
  
      if(!foundData){
        setDepartmentId("")
      }
    }
    
  }, [data, departmentId, setDepartmentId]);

  return (
      <div>
          <select id="employee-select-PagibigReport" disabled={!isEditMode} value={departmentId || ''} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
          <option value="">None</option>
          {data.map((departmentId) => ( 
              SetDepartmentId(departmentId)
          ))}
          </select>
      </div>
  );
};
function SetDepartmentId(departmentId){
  return(
      <option value={departmentId.id}>{
        departmentId.description}
      </option>
  )
  
}
function SectionIdSelect(sectionId, setSectionId, isEditMode){
  const [isSelected, setIsSelected] = useState(false);
  
  const handleSelectChange = (event) => {
      setIsSelected(true);
      setSectionId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
      const apiUrl =  domain + "/api/Section/active";

      await axios.get(apiUrl , {
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json' // You can include other headers if needed
      }})
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
          console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
      fetchData();
      if(sectionId !== "" && sectionId !== 0 && sectionId !== null && sectionId !== undefined){
          setIsSelected(true);
      } else {
          setIsSelected(false);
      }
  }, [sectionId]);

  useEffect(() => {
    if(sectionId){
      if (!data || data.length === 0) {
        return;
      }
  
      const foundData = data.find(i => i.id.toString() === sectionId.toString());
  
      if(!foundData){
        setSectionId("")
      }
    }
    
  }, [data, sectionId, setSectionId]);

  return (
      <div>
          <select id="employee-select-PagibigReport" disabled={!isEditMode} value={sectionId || ''} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
          <option value="">None</option>
          {data.map((sectionId) => ( 
              SetSectionId(sectionId)
          ))}
          </select>
      </div>
  );
};
function SetSectionId(sectionId){
  return(
      <option value={sectionId.id}>{
        sectionId.description}
      </option>
  )
  
}
function ClassificationIdSelect(classificationId, setClassificationId, isEditMode){
  const [isSelected, setIsSelected] = useState(false);
  
  const handleSelectChange = (event) => {
      setIsSelected(true);
      setClassificationId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
      const apiUrl =  domain + "/api/Classification/active";

      await axios.get(apiUrl , {
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json' // You can include other headers if needed
      }})
      .then(response => {
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
          console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
      fetchData();
      if(classificationId !== "" && classificationId !== 0 && classificationId !== null && classificationId !== undefined){
          setIsSelected(true);
      } else {
          setIsSelected(false);
      }
  }, [classificationId]);

  useEffect(() => {
    if(classificationId){
      if (!data || data.length === 0) {
        return;
      }
  
      const foundData = data.find(i => i.id.toString() === classificationId.toString());
  
      if(!foundData){
        setClassificationId("")
      }
    }
    
  }, [data, classificationId, setClassificationId]);

  return (
      <div>
          <select id="employee-select-PagibigReport" disabled={!isEditMode} value={classificationId || ''} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
          <option value="">None</option>
          {data.map((classificationId) => ( 
              SetClassificationId(classificationId)
          ))}
          </select>
      </div>
  );
};
function SetClassificationId(classificationId){
  return(
      <option value={classificationId.id}>{
        classificationId.description}
      </option>
  )
  
}
function PayTypeIdSelect(payTypeId, setPayTypeId, isEditMode){
  const [isSelected, setIsSelected] = useState(false);
  
  const handleSelectChange = (event) => {
      setIsSelected(true);
      setPayTypeId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
      const apiUrl = domain + "/api/PayType/active";

      await axios.get(apiUrl , {
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json' // You can include other headers if needed
      }})
      .then(response => {
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
          console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
      fetchData();
      if(payTypeId !== "" && payTypeId !== 0 && payTypeId !== null && payTypeId !== undefined){
          setIsSelected(true);
      } else {
          setIsSelected(false);
      }
  }, [payTypeId]);

  useEffect(() => {
    if(payTypeId){
      if (!data || data.length === 0) {
        return;
      }
  
      const foundData = data.find(i => i.id.toString() === payTypeId.toString());
  
      if(!foundData){
        setPayTypeId("")
      }
    }
    
  }, [data, payTypeId, setPayTypeId]);

  return (
      <div>
          <select id="employee-select-PagibigReport" disabled={!isEditMode} value={payTypeId || ''} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
          <option value="">None</option>
          {data.map((payTypeId) => ( 
              SetPayTypeId(payTypeId)
          ))}
          </select>
      </div>
  );
};
function SetPayTypeId(payTypeId){
  return(
      <option value={payTypeId.id}>{
        payTypeId.description}
      </option>
  )
  
}
function ShiftScheduleIdSelect(shiftScheduleId, setShiftScheduleId, isEditMode){
  const [isSelected, setIsSelected] = useState(false);
  
  const handleSelectChange = (event) => {
      setIsSelected(true);
      setShiftScheduleId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
      const apiUrl =  domain + "/api/ShiftSchedule";

      await axios.get(apiUrl , {
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json' // You can include other headers if needed
      }})
      .then(response => {
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
          console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
      fetchData();
      if(shiftScheduleId !== "" && shiftScheduleId !== 0 && shiftScheduleId !== null && shiftScheduleId !== undefined){
          setIsSelected(true);
      } else {
          setIsSelected(false);
      }
  }, [shiftScheduleId]);

  useEffect(() => {
    if(shiftScheduleId){
      if (!data || data.length === 0) {
        return;
      }
  
      const foundData = data.find(i => i.id.toString() === shiftScheduleId.toString());
  
      if(!foundData){
        setShiftScheduleId("")
      }
    }
    
  }, [data, shiftScheduleId, setShiftScheduleId]);

  return (
      <div>
          <select id="employee-select-PagibigReport" disabled={!isEditMode} value={shiftScheduleId || ''} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
          <option value="">None</option>
          {data.map((shiftScheduleId) => ( 
              SetShiftScheduleId(shiftScheduleId)
          ))}
          </select>
      </div>
  );
};
function SetShiftScheduleId(shiftScheduleId){
  const formatTime = (time) => {
    let timeParts;
    let formattedTime;

    if (globalTimeFormat === "Standard Time"){
        const timeSplit = time.split('T');
        if (timeSplit.length > 1) {
            timeParts = timeSplit[1].substr(0, 5).split(':');
        } else {
            timeParts = [];
        }
        let hours = parseInt(timeParts[0], 10);
        const minutes = timeParts[1];

        // Convert 24-hour format to 12-hour format and determine AM or PM
        const amPm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

        formattedTime = `${hours}:${minutes} ${amPm}`;
    } else if (globalTimeFormat === "Military Time"){
        const timeSplit = time.split('T');
        if (timeSplit.length > 1) {
            timeParts = timeSplit[1].substr(0, 5).split(':');
        } else {
            timeParts = [];
        }
        let hours = parseInt(timeParts[0], 10);
        const minutes = timeParts[1];

        formattedTime = `${hours}:${minutes}`;
    }

    return formattedTime;
  }

  return(
      <option id={"overtimeAdd" + shiftScheduleId.id} value={shiftScheduleId.id}>{`${shiftScheduleId.id} -  ${shiftScheduleId.shiftName} (${formatTime(shiftScheduleId.timeFrom)} - ${formatTime(shiftScheduleId.timeTo)}) `}</option>
  )
}
function PositionIdSelect(positionId, setPositionId, isEditMode){
  const [isSelected, setIsSelected] = useState(false);
  
  const handleSelectChange = (event) => {
      setIsSelected(true);
      setPositionId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
      const apiUrl =  domain + "/api/Position/active";

      await axios.get(apiUrl , {
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json' // You can include other headers if needed
      }})
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
          console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
      fetchData();
      if(positionId !== "" && positionId !== 0 && positionId !== null && positionId !== undefined){
          setIsSelected(true);
      } else {
          setIsSelected(false);
      }
  }, [positionId]);

  useEffect(() => {
    if(positionId){
      if (!data || data.length === 0) {
        return;
      }
  
      const foundData = data.find(i => i.id.toString() === positionId.toString());
  
      if(!foundData){
        setPositionId("")
      }
    }
    
  }, [data, positionId, setPositionId]);

  return (
      <div>
          <select id="employee-select-PagibigReport" disabled={!isEditMode} value={positionId || ''} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
          <option value="">None</option>
          {data.map((positionId) => ( 
              SetPositionId(positionId)
          ))}
          </select>
      </div>
  );
};
function SetPositionId(positionId){
  return(
      <option value={positionId.id}>{
        positionId.description}
      </option>
  )
  
}
function PlantilyaIdSelect({plantilyaId, setPlantilyaId, isEditMode}){
  const [isSelected, setIsSelected] = useState(false);
  
  const handleSelectChange = (event) => {
      setIsSelected(true);
      setPlantilyaId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
      const apiUrl =  domain + "/api/Plantilya/active";

      await axios.get(apiUrl , {
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json' // You can include other headers if needed
      }})
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
          console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
      fetchData();
      if(plantilyaId !== "" && plantilyaId !== 0 && plantilyaId !== null && plantilyaId !== undefined){
          setIsSelected(true);
      } else {
          setIsSelected(false);
      }
  }, [plantilyaId]);

  useEffect(() => {
    if(plantilyaId){
      if (!data || data.length === 0) {
        return;
      }
  
      const foundData = data.find(i => i.id.toString() === plantilyaId.toString());
  
      if(!foundData){
        setPlantilyaId("")
      }
    }
    
  }, [data, plantilyaId, setPlantilyaId]);

  return (
      <div>
          <select id="employee-select-PagibigReport" disabled={!isEditMode} value={plantilyaId || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
          <option value="">None</option>
          {data.map((plantilyaId) => ( 
              SetPlantilyaId(plantilyaId)
          ))}
          </select>
      </div>
  );
};
function SetPlantilyaId(plantilyaId){
  return(
      <option value={plantilyaId.id}>{
        plantilyaId.description}
      </option>
  )
  
}
function CostCenterSelect({costCenterId, setCostCenterId, isEditMode}){
  const [isSelected, setIsSelected] = useState(false);
  
  const handleSelectChange = (event) => {
      setIsSelected(true);
      setCostCenterId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
      const apiUrl =  domain + "/api/CostCenter/active";

      await axios.get(apiUrl , {
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json' // You can include other headers if needed
      }})
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
          console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
      fetchData();
      if(costCenterId !== "" && costCenterId !== 0 && costCenterId !== null && costCenterId !== undefined){
          setIsSelected(true);
      } else {
          setIsSelected(false);
      }
  }, [costCenterId]);

  useEffect(() => {
    if(costCenterId){
      if (!data || data.length === 0) {
        return;
      }
  
      const foundData = data.find(i => i.id.toString() === costCenterId.toString());
  
      if(!foundData){
        setCostCenterId("")
      }
    }
    
  }, [data, costCenterId, setCostCenterId]);

  return (
      <div>
          <select id="employee-select-PagibigReport" disabled={!isEditMode} value={costCenterId || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
          <option value="">None</option>
          {data.map((costCenterId) => ( 
              SetCostCenterId(costCenterId)
          ))}
          </select>
      </div>
  );
};
function SetCostCenterId(costCenterId){
  return(
      <option value={costCenterId.id}>{
        costCenterId.description}
      </option>
  )
  
}
function JobTitleIdSelect({jobTitleId, setJobTitleId, isEditMode}){
  const [isSelected, setIsSelected] = useState(false);
  
  const handleSelectChange = (event) => {
      setIsSelected(true);
      setJobTitleId(Number(event.target.value));
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
      const apiUrl =  domain + "/api/JobTitle/active";

      await axios.get(apiUrl , {
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json' // You can include other headers if needed
      }})
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
          console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
      fetchData();
      if(jobTitleId !== "" && jobTitleId !== 0 && jobTitleId !== null && jobTitleId !== undefined){
          setIsSelected(true);
      } else {
          setIsSelected(false);
      }
  }, [jobTitleId]);

  return (
      <div>
          <select id="employee-select-PagibigReport" disabled={!isEditMode} value={jobTitleId || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
          <option value="">None</option>
          {data.map((jobTitleId) => ( 
              SetJobTitleId(jobTitleId)
          ))}
          </select>
      </div>
  );
};
function SetJobTitleId(jobTitleId){
  return(
      <option value={jobTitleId.id}>{
        jobTitleId.description}
      </option>
  )
  
}
function EmployeeGroup1IdSelect({employeeGroup1Id, setEmployeeGroup1Id, isEditMode}){
  const [isSelected, setIsSelected] = useState(false);
  
  const handleSelectChange = (event) => {
      setIsSelected(true);
      setEmployeeGroup1Id(Number(event.target.value));
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
      const apiUrl =  domain + "/api/EmployeeGroup1/active";

      await axios.get(apiUrl , {
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json' // You can include other headers if needed
      }})
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
          console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
      fetchData();
      if(employeeGroup1Id !== "" && employeeGroup1Id !== 0 && employeeGroup1Id !== null && employeeGroup1Id !== undefined){
          setIsSelected(true);
      } else {
          setIsSelected(false);
      }
  }, [employeeGroup1Id]);

  useEffect(() => {
    if(employeeGroup1Id){
      if (!data || data.length === 0) {
        return;
      }
  
      const foundData = data.find(i => i.id.toString() === employeeGroup1Id.toString());
  
      if(!foundData){
        setEmployeeGroup1Id("")
      }
    }
    
  }, [data, employeeGroup1Id, setEmployeeGroup1Id]);

  return (
      <div>
          <select id="employee-select-PagibigReport" disabled={!isEditMode} value={employeeGroup1Id || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
          <option value="">None</option>
          {data.map((employeeGroup1Id) => ( 
              SetEmployeeGroup1Id(employeeGroup1Id)
          ))}
          </select>
      </div>
  );
};
function SetEmployeeGroup1Id(employeeGroup1Id){
  return(
      <option value={employeeGroup1Id.id}>{
        employeeGroup1Id.description}
      </option>
  )
  
}
function EmployeeGroup2IdSelect({employeeGroup2Id, setEmployeeGroup2Id, isEditMode}){
  const [isSelected, setIsSelected] = useState(false);
  
  const handleSelectChange = (event) => {
      setIsSelected(true);
      setEmployeeGroup2Id(Number(event.target.value));
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
      const apiUrl =  domain + "/api/EmployeeGroup2/active";

      await axios.get(apiUrl , {
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json' // You can include other headers if needed
      }})
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
          console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
      fetchData();
      if(employeeGroup2Id !== "" && employeeGroup2Id !== 0 && employeeGroup2Id !== null && employeeGroup2Id !== undefined){
          setIsSelected(true);
      } else {
          setIsSelected(false);
      }
  }, [employeeGroup2Id]);

  useEffect(() => {
    if(employeeGroup2Id){
      if (!data || data.length === 0) {
        return;
      }
  
      const foundData = data.find(i => i.id.toString() === employeeGroup2Id.toString());
  
      if(!foundData){
        setEmployeeGroup2Id("")
      }
    }
    
  }, [data, employeeGroup2Id, setEmployeeGroup2Id]);

  return (
      <div>
          <select id="employee-select-PagibigReport" disabled={!isEditMode} value={employeeGroup2Id || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
          <option value="">None</option>
          {data.map((employeeGroup2Id) => ( 
              SetEmployeeGroup2Id(employeeGroup2Id)
          ))}
          </select>
      </div>
  );
};
function SetEmployeeGroup2Id(employeeGroup2Id){
  return(
      <option value={employeeGroup2Id.id}>{
        employeeGroup2Id.description}
      </option>
  )
  
}
function ClientIdSelect({clientId, setClientId, isEditMode}){
  const [isSelected, setIsSelected] = useState(false);
  
  const handleSelectChange = (event) => {
      setIsSelected(true);
      setClientId(Number(event.target.value));
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
      const apiUrl =  domain + "/api/Client/active";

      await axios.get(apiUrl , {
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json' // You can include other headers if needed
      }})
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
          console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
      fetchData();
      if(clientId !== "" && clientId !== 0 && clientId !== null && clientId !== undefined){
          setIsSelected(true);
      } else {
          setIsSelected(false);
      }
  }, [clientId]);

  return (
      <div>
          <select id="employee-select-PagibigReport" disabled={!isEditMode} value={clientId || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
          <option value="">None</option>
          {data.map((clientId) => ( 
              SetClientId(clientId)
          ))}
          </select>
      </div>
  );
};
function SetClientId(clientId){
  return(
      <option value={clientId.id}>{
        clientId.description}
      </option>
  )
  
}

function EducationAddForm({
  isOpen,
  onClose,
  employeeId,
  addEmployeesEducation
}){
  const [level, setLevel] = useState('');
  const [schoolName, setSchoolName] = useState('');
  const [address, setAddress] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [course, setCourse] = useState('');
  const [honors, setHonors] = useState('');

  const handleSubmit = () => {
    if (!level 
      || !schoolName
      || !address
      || !dateFrom
      || !dateTo
      || !course
    ) {
      alert("Required to fill up all data");
      return; // Exit early if fields are empty
    }

    addEmployeesEducation(employeeId, level, schoolName, address, dateFrom, dateTo, course, honors);
    // Clear form fields
    setLevel('');
    setSchoolName('');
    setAddress('');
    setDateFrom('');
    setDateTo('');
    setCourse('');
    setHonors('');
  };

  const handleClose = ()=>{
    onClose();
    setLevel('');
    setSchoolName('');
    setAddress('');
    setDateFrom('');
    setDateTo('');
    setCourse('');
    setHonors('');
  }

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
          {isOpen && (
          <div className="modal">
            <div id="education-form" className="add-employees-form">
              <div className="popUp-header row">
                  <div className='popUp-title'><h3 style={{color:"#668fca"}}>Add Education Background</h3></div>
                  <div className='popUp-close'><CloseIcon onClick={()=>handleClose()}/></div>
              </div>
              <div className="popUp-body">
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Level</div>
                    <div className="info-item-input"><input id="AddEmployee-Level" placeholder="Level" onChange={(e) => setLevel(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">School Name</div>
                    <div className="info-item-input"><input id="AddEmployee-SchoolName" placeholder="School Name" onChange={(e) => setSchoolName(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Address</div>
                    <div className="info-item-input"><input id="AddEmployee-Address" placeholder="Address" onChange={(e) => setAddress(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Date From</div>
                    <div className="info-item-input">
                      <DateInput2 id="Education-DateFrom" value={dateFrom} onChange={(value) => setDateFrom(value)} />
                    </div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Date To</div>
                    <div className="info-item-input">
                      <DateInput2 id="Education-DateTo" value={dateTo} onChange={(value) => setDateTo(value)}/>
                    </div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Course</div>
                    <div className="info-item-input"><input id="AddEmployee-Course" placeholder="Course" onChange={(e) => setCourse(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Honors</div>
                    <div className="info-item-input"><input id="AddEmployee-Honors" placeholder="Honors" onChange={(e) => setHonors(e.target.value)}/></div>
                  </div>
                  <div className="educations-tab-footer tab-footer">
                <div className="buttons row" style={{justifyContent:"end"}}>
                  <button id="add-education" 
                          className="save row"
                          onClick={handleSubmit}>
                            SAVE
                  </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        </div>
    </>
  )
}
function EducationEditForm({
  isOpen,
  onClose,
  editData,
  employeeId,
  addEmployeesEducation
}){
  const [level, setLevel] = useState('');
  const [schoolName, setSchoolName] = useState('');
  const [address, setAddress] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [course, setCourse] = useState('');
  const [honors, setHonors] = useState('');

  const handleSubmit = () => {
    if (!level 
      || !schoolName
      || !address
      || !dateFrom
      || !dateTo
      || !course
    ) {
      alert("Required to fill up all data");
      return; // Exit early if fields are empty
    }

  addEmployeesEducation(employeeId, level, schoolName, address, dateFrom, dateTo, course, honors);
    // Clear form fields
    setLevel('');
    setSchoolName('');
    setAddress('');
    setDateFrom('');
    setDateTo('');
    setCourse('');
    setHonors('');
  };

  const handleClose = ()=>{
    onClose();
    setLevel('');
    setSchoolName('');
    setAddress('');
    setDateFrom('');
    setDateTo('');
    setCourse('');
    setHonors('');
  }

  useEffect(() => {
    if(isOpen){
      setLevel(editData.level);
      setSchoolName(editData.schoolName);
      setAddress(editData.address);
      setDateFrom(editData.dateFrom);
      setDateTo(editData.dateTo);
      setCourse(editData.course);
      setHonors(editData.honors);
    }
  }, [isOpen, editData]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
          {isOpen && (
          <div className="modal">
            <div id="education-form" className="add-employees-form">
              <div className="popUp-header row">
                  <div className='popUp-title'><h3 style={{color:"#668fca"}}>Edit Education Background</h3></div>
                  <div className='popUp-close'><CloseIcon onClick={()=>handleClose()}/></div>
              </div>
              <div className="popUp-body">
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Level</div>
                    <div className="info-item-input"><input id="AddEmployee-Level" value={level} placeholder="Level" onChange={(e) => setLevel(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">School Name</div>
                    <div className="info-item-input"><input id="AddEmployee-SchoolName" value={schoolName} placeholder="School Name" onChange={(e) => setSchoolName(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Address</div>
                    <div className="info-item-input"><input id="AddEmployee-Address" value={address} placeholder="Address" onChange={(e) => setAddress(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Date From</div>
                    <div className="info-item-input">
                      <DateInput2 id="Education-DateFrom" value={dateFrom} onChange={(value) => setDateFrom(value)} />
                    </div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Date To</div>
                    <div className="info-item-input">
                      <DateInput2 id="Education-DateTo" value={dateTo} onChange={(value) => setDateTo(value)}/>
                    </div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Course</div>
                    <div className="info-item-input"><input id="AddEmployee-Course" value={course} placeholder="Course" onChange={(e) => setCourse(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Honors</div>
                    <div className="info-item-input"><input id="AddEmployee-Honors" value={honors} placeholder="Honors" onChange={(e) => setHonors(e.target.value)}/></div>
                  </div>
                  <div className="educations-tab-footer tab-footer">
                <div className="buttons row" style={{justifyContent:"end"}}>
                  <button id="add-education" 
                          className="save row"
                          onClick={handleSubmit}>
                            SAVE
                  </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        </div>
    </>
  )
}
function DependentsAddForm(
  {isOpen,
  onClose,
  employeeId,
  addEmployeesDependets}){
  const [lastName, setLastName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [middleName, setMiddleName] = useState('');
  const [extensionName, setExtensionName] = useState('');
  const [dateOfBirth, setDateOfBirth] = useState('');
  const [gender, setGender] = useState('');
  const [civilStatus, setCivilStatus] = useState('');

  const handleSubmit = () => {
    if (!lastName 
      || !firstName
      || !middleName
      || !dateOfBirth
      || !gender
      || !civilStatus
    ) {
      alert("Required to fill up all data");
      return; // Exit early if fields are empty
    }

    addEmployeesDependets(employeeId, lastName, firstName, middleName, extensionName, dateOfBirth, gender, civilStatus);
    // Clear form fields
    setLastName('');
    setFirstName('');
    setMiddleName('');
    setExtensionName('');
    setDateOfBirth('');
    setGender('');
    setCivilStatus('');
  };

  const handleClose = ()=>{
    onClose();
    setLastName('');
    setFirstName('');
    setMiddleName('');
    setExtensionName('');
    setDateOfBirth('');
    setGender('');
    setCivilStatus('');
  }

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
          {isOpen && (
          <div className="modal">
            <div id="dependents-form" className="add-employees-form">
              <div className="popUp-header row">
                  <div className='popUp-title'><h3 style={{color:"#668fca"}}>Add Dependents</h3></div>
                  <div className='popUp-close'><CloseIcon onClick={()=>handleClose()}/></div>
              </div>
              <div className="popUp-body">
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Last Name</div>
                    <div className="info-item-input"><input id="AddEmployee-Dependents-LastName" placeholder="Last Name" onChange={(e) => setLastName(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">First Name</div>
                    <div className="info-item-input"><input id="AddEmployee-Dependents-FirstName" placeholder="First Name" onChange={(e) => setFirstName(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Middle Name</div>
                    <div className="info-item-input"><input id="AddEmployee-Dependents-MiddleName" placeholder="Middle Name" onChange={(e) => setMiddleName(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Extension Name</div>
                    <div className="info-item-input"><input id="AddEmployee-Dependents-ExtensionName" placeholder="Extension Name" onChange={(e) => setExtensionName(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Date of Birth</div>
                    <div className="info-item-input"><DateInput2 id="Dependents-DateOfBirth" value={dateOfBirth} onChange={(value) => setDateOfBirth(value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Gender</div>
                    <div className="info-item-input"><Gender2 id="Dependents-Gender" value={gender} onChange={(value) => setGender(value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Civil Status</div>
                    <div className="info-item-input"><CivilStatus2 id="Dependents-CivilStatus" value={civilStatus} onChange={(value) => setCivilStatus(value)}/></div>
                  </div>
                  <div className="dependents-tab-footer tab-footer">
                <div className="buttons row" style={{justifyContent:"end"}}>
                    <button id="add-dependents" 
                          className="save row"
                          onClick={handleSubmit}>
                            SAVE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        </div>
    </>
  )
}
function DependentsEditForm(
  {isOpen,
  onClose,
  editData,
  employeeId,
  addEmployeesDependets}){
  const [lastName, setLastName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [middleName, setMiddleName] = useState('');
  const [extensionName, setExtensionName] = useState('');
  const [dateOfBirth, setDateOfBirth] = useState('');
  const [gender, setGender] = useState('');
  const [civilStatus, setCivilStatus] = useState('');

  const handleSubmit = () => {
    if (!lastName 
      || !firstName
      || !middleName
      || !dateOfBirth
      || !gender
      || !civilStatus
    ) {
      alert("Required to fill up all data");
      return; // Exit early if fields are empty
    }

    addEmployeesDependets(employeeId, lastName, firstName, middleName, extensionName, dateOfBirth, gender, civilStatus);
    // Clear form fields
    setLastName('');
    setFirstName('');
    setMiddleName('');
    setExtensionName('');
    setDateOfBirth('');
    setGender('');
    setCivilStatus('');
  };
  const handleClose = ()=>{
    onClose();
    setLastName('');
    setFirstName('');
    setMiddleName('');
    setExtensionName('');
    setDateOfBirth('');
    setGender('');
    setCivilStatus('');
  }

  useEffect(() => {
    if(isOpen){
      setLastName(editData.lastName);
      setFirstName(editData.firstName);
      setMiddleName(editData.middleName);
      setExtensionName(editData.extensionName);
      setDateOfBirth(editData.dateOfBirth);
      setGender(editData.gender);
      setCivilStatus(editData.civilStatus);
    }
  }, [isOpen, editData]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
          {isOpen && (
          <div className="modal">
            <div id="dependents-form" className="add-employees-form">
              <div className="popUp-header row">
                  <div className='popUp-title'><h3 style={{color:"#668fca"}}>Edit Dependents</h3></div>
                  <div className='popUp-close'><CloseIcon onClick={()=>handleClose()}/></div>
              </div>
              <div className="popUp-body">
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Last Name</div>
                    <div className="info-item-input"><input value={lastName} id="AddEmployee-Dependents-LastName" placeholder="Last Name" onChange={(e) => setLastName(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">First Name</div>
                    <div className="info-item-input"><input value={firstName} id="AddEmployee-Dependents-FirstName" placeholder="First Name" onChange={(e) => setFirstName(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Middle Name</div>
                    <div className="info-item-input"><input value={middleName} id="AddEmployee-Dependents-MiddleName" placeholder="Middle Name" onChange={(e) => setMiddleName(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Extension Name</div>
                    <div className="info-item-input"><input value={extensionName} id="AddEmployee-Dependents-ExtensionName" placeholder="Extension Name" onChange={(e) => setExtensionName(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Date of Birth</div>
                    <div className="info-item-input"><DateInput2 id="Dependents-DateOfBirth" value={dateOfBirth} onChange={(value) => setDateOfBirth(value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Gender</div>
                    <div className="info-item-input"><Gender2 id="Dependents-Gender" value={gender} onChange={(value) => setGender(value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Civil Status</div>
                    <div className="info-item-input"><CivilStatus2 id="Dependents-CivilStatus" value={civilStatus} onChange={(value) => setCivilStatus(value)}/></div>
                  </div>
                  <div className="dependents-tab-footer tab-footer">
                <div className="buttons row" style={{justifyContent:"end"}}>
                    <button id="add-dependents" 
                          className="save row"
                          onClick={handleSubmit}>
                            SAVE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        </div>
    </>
  )
}
function EmergencyAddForm({isOpen,
  onClose,
  employeeId,
  addEmployeesEmergency
}){
  const [name, setName] = useState('');
  const [relationship, setRelationship] = useState('');
  const [contactNo, setContactNo] = useState('');
  const [address, setAddress] = useState('');

  const handleSubmit = () => {
    if (!name 
      || !relationship
      || !contactNo
      || !address
    ) {
      alert("Required to fill up all data");
      return; // Exit early if fields are empty
    }

    addEmployeesEmergency(employeeId,name, relationship, contactNo, address);
    // Clear form fields
    setName('');
    setRelationship('');
    setContactNo('');
    setAddress('');
  };

  const handleClose = ()=>{
    onClose();
    setName('');
    setRelationship('');
    setContactNo('');
    setAddress('');
  }

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
          {isOpen && (
          <div className="modal">
            <div id="emergency-form" className="add-employees-form">
              <div className="popUp-header row">
                  <div className='popUp-title'><h3 style={{color:"#668fca"}}>Add Emergency Contact</h3></div>
                  <div className='popUp-close'><CloseIcon onClick={()=>handleClose()}/></div>
              </div>
              <div className="popUp-body">
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Name</div>
                    <div className="info-item-input"><input id="AddEmployee-Emergency-Name" placeholder="Name" onChange={(e) => setName(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Relationship</div>
                    <div className="info-item-input"><input id="AddEmployee-Emergency-Relationship" placeholder="Relationship" onChange={(e) => setRelationship(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Address</div>
                    <div className="info-item-input"><input id="AddEmployee-Emergency-Address" placeholder="Middle Address" onChange={(e) => setAddress(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Contact Number</div>
                    <div className="info-item-input"><input id="AddEmployee-Emergency-ContactNumber" placeholder="Contact Number" onChange={(e) => setContactNo(e.target.value)}/></div>
                  </div>
                  <div className="emergency-tab-footer tab-footer">
                <div className="buttons row" style={{justifyContent:"end"}}>
                      <button id="add-emergency" 
                          className="save row"
                          onClick={handleSubmit}>
                            SAVE
                      </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        </div>
    </>
  )
}
function EmergencyEditForm({isOpen,
  onClose,
  editData,
  employeeId,
  addEmployeesEmergency
}){
  const [name, setName] = useState('');
  const [relationship, setRelationship] = useState('');
  const [contactNo, setContactNo] = useState('');
  const [address, setAddress] = useState('');

  const handleSubmit = () => {
    if (!name 
      || !relationship
      || !contactNo
      || !address
    ) {
      alert("Required to fill up all data");
      return; // Exit early if fields are empty
    }

    addEmployeesEmergency(employeeId,name, relationship, contactNo, address);
    // Clear form fields
    setName('');
    setRelationship('');
    setContactNo('');
    setAddress('');
  };

  const handleClose = ()=>{
    onClose();
    setName('');
    setRelationship('');
    setContactNo('');
    setAddress('');
  }

  useEffect(() => {
    if(isOpen){
      setName(editData.name);
      setRelationship(editData.relationship);
      setContactNo(editData.contactNo);
      setAddress(editData.address);
    }
  }, [isOpen, editData]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
          {isOpen && (
          <div className="modal">
            <div id="emergency-form" className="add-employees-form">
              <div className="popUp-header row">
                  <div className='popUp-title'><h3 style={{color:"#668fca"}}>Edit Emergency Contact</h3></div>
                  <div className='popUp-close'><CloseIcon onClick={()=>handleClose()}/></div>
              </div>
              <div className="popUp-body">
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Name</div>
                    <div className="info-item-input"><input value={name} id="AddEmployee-Emergency-Name" placeholder="Name" onChange={(e) => setName(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Relationship</div>
                    <div className="info-item-input"><input value={relationship} id="AddEmployee-Emergency-Relationship" placeholder="Relationship" onChange={(e) => setRelationship(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Address</div>
                    <div className="info-item-input"><input value={address} id="AddEmployee-Emergency-Address" placeholder="Middle Address" onChange={(e) => setAddress(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Contact Number</div>
                    <div className="info-item-input"><input value={contactNo} id="AddEmployee-Emergency-ContactNumber" placeholder="Contact Number" onChange={(e) => setContactNo(e.target.value)}/></div>
                  </div>
                  <div className="emergency-tab-footer tab-footer">
                <div className="buttons row" style={{justifyContent:"end"}}>
                      <button id="add-emergency" 
                          className="save row"
                          onClick={handleSubmit}>
                            SAVE
                      </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        </div>
    </>
  )
}
function FamilyAddForm({
  isOpen,
  onClose,
  employeeId,
  addEmployeesFamily}){
  const [name, setName] = useState('');
  const [dateOfBirth, setDateOfBirth] = useState('');
  const [occupation, setOccupation] = useState('');
  const [contactNo, setContactNo] = useState('');
  const [age, setAge] = useState('');
  const [address, setAddress] = useState('');
  const [relationship, setRelationship] = useState('');

  const handleSubmit = () => {
    if (!name 
      || !dateOfBirth
      || !contactNo
      || !address
      || !age
      || !relationship
    ) {
      alert("Required to fill up all data");
      return; // Exit early if fields are empty
    }

    addEmployeesFamily(employeeId, name, dateOfBirth, occupation, contactNo, age, address, relationship );
    // Clear form fields
    setName('');
    setDateOfBirth('');
    setOccupation('');
    setContactNo('');
    setAge('');
    setAddress('');
    setRelationship('');
  };

  const handleClose = ()=>{
    onClose();
    setName('');
    setDateOfBirth('');
    setOccupation('');
    setContactNo('');
    setAge('');
    setAddress('');
    setRelationship('');
  }

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
          {isOpen && (
          <div className="modal">
            <div id="family-form" className="add-employees-form">
              <div className="popUp-header row">
                  <div className='popUp-title'><h3 style={{color:"#668fca"}}>Add Family</h3></div>
                  <div className='popUp-close'><CloseIcon onClick={()=>handleClose()}/></div>
              </div>
              <div className="popUp-body">
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Name</div>
                    <div className="info-item-input"><input id="AddEmployee-Family-Name" placeholder="Name" onChange={(e) => setName(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Date Of Birth</div>
                    <div className="info-item-input"><DateInput2 id="Family-DateOfBirth" value={dateOfBirth} onChange={(value) => setDateOfBirth(value)} /></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Occupation</div>
                    <div className="info-item-input"><input id="AddEmployee-Family-Occupation" placeholder="Occupation" onChange={(e) => setOccupation(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Contact Number</div>
                    <div className="info-item-input"><input id="AddEmployee-Family-ContactNumber" placeholder="Contact Number" onChange={(e) => setContactNo(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Age</div>
                    <div className="info-item-input"><Age2 id="Family-Age" value={age} onChange={(value) => setAge(value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Relationship</div>
                    <div className="info-item-input"><input id="AddEmployee-Family-Relationship" placeholder="Relationship" onChange={(e) => setRelationship(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Address</div>
                    <div className="info-item-input"><input id="AddEmployee-Family-Address" placeholder="Address" onChange={(e) => setAddress(e.target.value)}/></div>
                  </div>
                  <div className="family-tab-footer tab-footer">
                <div className="buttons row" style={{justifyContent:"end"}}>
                      <button id="add-family" 
                          className="save row"
                          onClick={handleSubmit}>
                            SAVE
                      </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}
function FamilyEditForm({
  isOpen,
  onClose,
  editData,
  employeeId,
  addEmployeesFamily}){
  const [name, setName] = useState('');
  const [dateOfBirth, setDateOfBirth] = useState('');
  const [occupation, setOccupation] = useState('');
  const [contactNo, setContactNo] = useState('');
  const [age, setAge] = useState('');
  const [address, setAddress] = useState('');
  const [relationship, setRelationship] = useState('');

  const handleSubmit = () => {
    if (!name 
      || !dateOfBirth
      || !contactNo
      || !address
      || !age
      || !relationship
    ) {
      alert("Required to fill up all data");
      return; // Exit early if fields are empty
    }

    addEmployeesFamily(employeeId, name, dateOfBirth, occupation, contactNo, age, address, relationship );
    // Clear form fields
    setName('');
    setDateOfBirth('');
    setOccupation('');
    setContactNo('');
    setAge('');
    setAddress('');
    setRelationship('');
  };
  const handleClose = ()=>{
    onClose();
    setName('');
    setDateOfBirth('');
    setOccupation('');
    setContactNo('');
    setAge('');
    setAddress('');
    setRelationship('');
  }
  useEffect(() => {
    if(isOpen){
      setName(editData.name);
      setDateOfBirth(editData.dateOfBirth);
      setOccupation(editData.occupation);
      setContactNo(editData.contactNo);
      setAge(editData.age);
      setAddress(editData.address);
      setRelationship(editData.relationship);
    }
  }, [isOpen, editData]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
          {isOpen && (
          <div className="modal">
            <div id="family-form" className="add-employees-form">
              <div className="popUp-header row">
                  <div className='popUp-title'><h3 style={{color:"#668fca"}}>Add Family</h3></div>
                  <div className='popUp-close'><CloseIcon onClick={()=>handleClose()}/></div>
              </div>
              <div className="popUp-body">
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Name</div>
                    <div className="info-item-input"><input value={name} id="AddEmployee-Family-Name" placeholder="Name" onChange={(e) => setName(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Date Of Birth</div>
                    <div className="info-item-input"><DateInput2 id="Family-DateOfBirth" value={dateOfBirth} onChange={(value) => setDateOfBirth(value)} /></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Occupation</div>
                    <div className="info-item-input"><input value={occupation} id="AddEmployee-Family-Occupation" placeholder="Occupation" onChange={(e) => setOccupation(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Contact Number</div>
                    <div className="info-item-input"><input value={contactNo} id="AddEmployee-Family-ContactNumber" placeholder="Contact Number" onChange={(e) => setContactNo(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Age</div>
                    <div className="info-item-input"><input value={age} id="AddEmployee-Family-Age" placeholder="Age" onChange={(e) => setAge(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Relationship</div>
                    <div className="info-item-input"><input value={relationship} id="AddEmployee-Family-Relationship" placeholder="Relationship" onChange={(e) => setRelationship(e.target.value)}/></div>
                  </div>
                  <div className="popUp-item info-item column">
                    <div className="info-item-label">Address</div>
                    <div className="info-item-input"><input value={address} id="AddEmployee-Family-Address" placeholder="Address" onChange={(e) => setAddress(e.target.value)}/></div>
                  </div>
                  <div className="family-tab-footer tab-footer">
                <div className="buttons row" style={{justifyContent:"end"}}>
                      <button id="add-family" 
                          className="save row"
                          onClick={handleSubmit}>
                            SAVE
                      </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

function Previous(currentSelected){
  if(currentSelected !== 0){ return (currentSelected - 1); } else { return currentSelected }
}
function Next(currentSelected){
  if(currentSelected !== 8){ return(currentSelected + 1); } else { return currentSelected }
}
export function CreateTable({ dataList = [], dataHeader = [], dataAccessor = [], editHandleClick, deleteHandleClick, isEditMode }) {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const columns = React.useMemo(() =>
      dataHeader.map((header, index) => ({
          Header: header,
          accessor: dataAccessor[index]
      })),
      [dataHeader, dataAccessor]
  );

  const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      prepareRow
  } = useTable({ columns, data: dataList });

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
      if (pageNumber >= 1 && pageNumber <= totalPages) {
          setCurrentPage(pageNumber);
      }
  };

  return (
      <div>
          <table {...getTableProps()} className='border-collapse'>
              <thead>
                  {headerGroups.map((headerGroup) => (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                          {headerGroup.headers.map((column) => (
                              <th {...column.getHeaderProps()}>
                                  {
                                  column.render("Header")
                                  }
                              </th>
                          ))}
                      </tr>
                  ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                  {dataList.length <= 0 &&
                      <tr>
                          <td colSpan={columns.length} style={{ textAlign: "center" }}>
                              No data to display
                          </td>
                      </tr>
                  }
                  {currentItems.map((row) => {
                      prepareRow(row)
                      return (
                          <tr key={row.original.id}
                          {...row.getRowProps()}
                          >
                              {row.cells.map((cell) => (
                                  SetInfo(cell.render("Cell").props.column.Header, 
                                          cell,
                                          editHandleClick,
                                          deleteHandleClick,
                                          isEditMode)
                              ))}
                          </tr>
                      )
                  })}
              </tbody>
          </table>
          {rows.length > itemsPerPage ? (
          <div>
              <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                  <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                          style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                      &lt;&lt;
                  </button>
                  <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                          style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                      <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                  </button>
                  <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                      style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                      NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                  </button>
                  <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                      style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                      &gt;&gt;
                  </button>
              </div>
              {`${currentPage}/${totalPages}`}
          </div>
          ) :
          <></>}
      </div>
  )
}
function SetInfo(header, _cell, editHandleClick, deleteHandleClick, isEditMode) {
  const data = _cell.render("Cell").props.row.original;
  const value = _cell.render("Cell").props.value;

  if (header === "") {
      return(
          <td>
              {isEditMode ?
              <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                  <Tooltip text="Update">
                      <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><ModeEditIcon/></div>
                  </Tooltip>
                  { deleteHandleClick ? 
                  <Tooltip text="Delete">
                      <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><DeleteForeverIcon/></div>
                  </Tooltip>
                  :
                  <></>
                  }
              </div>
              : <></>
              }
          </td>
      )
  }

  if(header === "Status"){
      if(data.isActive){  
          return(
              <td>
                  Active
              </td>
          )
      }
      else{
          return(
              <td>
                  InActive
              </td>
          )
      }
  }

  if(header === "Approved?"){
      return(
          <td>
              <input type="checkbox" 
                  id="overtime-allowance" 
                  className="checkbox"
                  name="" 
                  checked={data.isActive}
                  disabled={true}
              />
          </td>
      )
  }

  if(header === "Time From"){
      const time = _cell.render("Cell").props.row.original.timeFrom;

      const timeParts = time.split('T')[1].substr(0, 5).split(':'); // Extract hours and minutes
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];

      // Convert 24-hour format to 12-hour format and determine AM or PM
      const amPm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

      const formattedTime = `${hours}:${minutes} ${amPm}`;

      return (
          <td>
              {formattedTime}
          </td>
      );
  }

  if(header === "Time To"){
      const time = _cell.render("Cell").props.row.original.timeTo;

      const timeParts = time.split('T')[1].substr(0, 5).split(':'); // Extract hours and minutes
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];

      // Convert 24-hour format to 12-hour format and determine AM or PM
      const amPm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

      const formattedTime = `${hours}:${minutes} ${amPm}`;

      return (
          <td>
              {formattedTime}
          </td>
      );
  }
  
  if(header === "Date"
    || header === "Date From"
    || header === "Date To"
    || header === "Date Processed"
    || header === "Request Date"
    || header === "Date Of Birth"
    ){
      if(!value){
        return (
            <td>
            </td>
        );
      }
      const date = new Date(_cell.render("Cell").props.value);
      if(!date) {
          return (
              <td>
                  null
              </td>
          );
      }

      const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
      const dd = date.getDate();
      const yyyy = date.getFullYear();

      const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
      
      return(
          <td>
              {formattedDateFrom}
          </td>
      )
  }

  //Double type data
  if(header === "Over Percentage"
  || header === "Deduction"
  || header === "Salary"
  || header === "Employee"
  || header === "Employer"
  || header === "Range From"
  || header === "Range To	"
  || header === "Monthly Salary"
  || header === "SSS ER"
  || header === "SSS EE"
  || header === "SSS Total"
  || header === "ECER"
  || header === "Total Contribution ER"
  || header === "Total Contribution EE"
  || header === "Total Contribution Total"
  || header === "SE Total Contribution"
  || header === "Salary Range From"
  || header === "Salary Range To"
  || header === "Total Monthly Premium"
  || header === "Percentage"
  || header === "Amount"
  || header === "Total Loan"
  || header === "Total Balance"
  || header === "Default Deduction"
  || header === "Allowance"
  || header === "Daily Salary"
  || header === "Allowance"
  || header === "Total Basic"
  || header === "Rate"
  || header === "Hours OT Regular"
  || header === "Total OT Regular"
  || header === "Hours OT Exceeded"
  || header === "Total OT Exceeded"
  || header === "Hours OT Restday"
  || header === "Total OT Restday"
  || header === "Hours Holiday Special"
  || header === "Total Holiday Special"
  || header === "Hours Holiday Regular"
  || header === "Total Holiday Regular"
  || header === "Hours Restday Holiday Special"
  || header === "Total Restday Holiday Special"
  || header === "Hours Restday Holiday Regular"
  || header === "Total Restday Holiday Regular"
  || header === "Additions"
  || header === "SSS"
  || header === "Pagibig"
  || header === "Philhealth"
  || header === "SSS Loan"
  || header === "SSS Calamity Loan"
  || header === "Pagibig Loan"
  || header === "Pagibig Calamity Loan"
  || header === "Tax"
  || header === "Deductions"
  || header === "Adjustments"
  || header === "Total Net Pay"
  || header === "Days Absent"
  || header === "Absent/s"
  || header === "Days Leave"
  || header === "Leave/s"
  || header === "Hours Exceeded"
  || header === "Total Exceeded"
  || header === "Hours Undertime"
  || header === "Undertime"
  || header === "Hours Late"
  ){
      const value = _cell.render("Cell").props.value;

      // Check if value is a number
      const isNumber = typeof value === 'number';

      const numberWithCommasAndDecimal = (number) => {
          return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      };

      if(!isNumber){
          return (
              <td {..._cell.getCellProps()}> {
                  _cell.render("Cell")
                  }
              </td>
          )
      }

      const formattedNumber = numberWithCommasAndDecimal(value);

      return(
          <td>
              {formattedNumber}
          </td>
      )
  }

  return (
      <td {..._cell.getCellProps()}> {
          _cell.render("Cell")
          }
      </td>
  )
}
export function CreateTable2({ dataList = [], dataHeader = [], dataAccessor = [], editHandleClick, downloadHandleClick, isEditMode }) {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const columns = React.useMemo(() =>
      dataHeader.map((header, index) => ({
          Header: header,
          accessor: dataAccessor[index]
      })),
      [dataHeader, dataAccessor]
  );

  const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      prepareRow
  } = useTable({ columns, data: dataList });

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
      if (pageNumber >= 1 && pageNumber <= totalPages) {
          setCurrentPage(pageNumber);
      }
  };

  return (
      <div>
          <table {...getTableProps()} className='border-collapse'>
              <thead>
                  {headerGroups.map((headerGroup) => (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                          {headerGroup.headers.map((column) => (
                              <th {...column.getHeaderProps()}>
                                  {
                                  column.render("Header")
                                  }
                              </th>
                          ))}
                      </tr>
                  ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                  {dataList.length <= 0 &&
                      <tr>
                          <td colSpan={columns.length} style={{ textAlign: "center" }}>
                              No data to display
                          </td>
                      </tr>
                  }
                  {currentItems.map((row) => {
                      prepareRow(row)
                      return (
                          <tr key={row.original.id}
                          {...row.getRowProps()}
                          >
                              {row.cells.map((cell) => (
                                  SetInfo2(cell.render("Cell").props.column.Header, 
                                          cell,
                                          editHandleClick,
                                          downloadHandleClick,
                                          isEditMode)
                              ))}
                          </tr>
                      )
                  })}
              </tbody>
          </table>
          {rows.length > itemsPerPage ? (
          <div>
              <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                  <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                          style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                      &lt;&lt;
                  </button>
                  <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                          style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                      <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                  </button>
                  <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                      style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                      NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                  </button>
                  <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                      style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                      &gt;&gt;
                  </button>
              </div>
              {`${currentPage}/${totalPages}`}
          </div>
          ) :
          <></>}
      </div>
  )
}
function SetInfo2(header, _cell, editHandleClick, downloadHandleClick, isEditMode) {
  const data = _cell.render("Cell").props.row.original;
  const value = _cell.render("Cell").props.value;

  if (header === "") {
      return(
          <td>
              {isEditMode ?
              <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                  <Tooltip text="Update">
                      <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><ModeEditIcon/></div>
                  </Tooltip>
              </div>
              : <></>
              }
          </td>
      )
  }
  if (header === "File") {
    if(!value){
      return (<td>No uploaded file yet.</td>)
    }

      return(
          <td>
              <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                  { downloadHandleClick ? 
                  <Tooltip text="Download">
                      <div style={{padding:"0 5px"}} onClick={()=>downloadHandleClick(data)}><DownloadIcon
                        className='hover:text-white hover:bg-blue-500 text-blue-500 cursor-pointer rounded-md'
                        style={{border: "1px solid #2196F3"}}
                      /></div>
                  </Tooltip>
                  :
                  <></>
                  }
              </div>
          </td>
      )
  }

  if(header === "Status" || header === "Is Active?"){
      if(data.isActive){  
          return(
              <td>
                  Active
              </td>
          )
      }
      else{
          return(
              <td>
                  InActive
              </td>
          )
      }
  }
  if(header === "Has Completed?"){
      if(value){  
          return(
              <td>
                  Yes
              </td>
          )
      }
      else{
          return(
              <td>
                  No
              </td>
          )
      }
  }

  if(header === "Approved?"){
      return(
          <td>
              <input type="checkbox" 
                  id="overtime-allowance" 
                  className="checkbox"
                  name="" 
                  checked={data.isActive}
                  disabled={true}
              />
          </td>
      )
  }

  if(header === "Time From"){
      const time = _cell.render("Cell").props.row.original.timeFrom;

      const timeParts = time.split('T')[1].substr(0, 5).split(':'); // Extract hours and minutes
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];

      // Convert 24-hour format to 12-hour format and determine AM or PM
      const amPm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

      const formattedTime = `${hours}:${minutes} ${amPm}`;

      return (
          <td>
              {formattedTime}
          </td>
      );
  }

  if(header === "Time To"){
      const time = _cell.render("Cell").props.row.original.timeTo;

      const timeParts = time.split('T')[1].substr(0, 5).split(':'); // Extract hours and minutes
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];

      // Convert 24-hour format to 12-hour format and determine AM or PM
      const amPm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

      const formattedTime = `${hours}:${minutes} ${amPm}`;

      return (
          <td>
              {formattedTime}
          </td>
      );
  }
  
  if(header === "Date"
    || header === "Date From"
    || header === "Date To"
    || header === "Date Processed"
    || header === "Request Date"
    || header === "Date Of Birth"
    ){
      if(!value){
        return (
            <td>
            </td>
        );
      }
      const date = new Date(_cell.render("Cell").props.value);
      if(!date) {
          return (
              <td>
                  null
              </td>
          );
      }

      const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
      const dd = date.getDate();
      const yyyy = date.getFullYear();

      const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
      
      return(
          <td>
              {formattedDateFrom}
          </td>
      )
  }

  //Double type data
  if(header === "Over Percentage"
  || header === "Deduction"
  || header === "Salary"
  || header === "Employee"
  || header === "Employer"
  || header === "Range From"
  || header === "Range To	"
  || header === "Monthly Salary"
  || header === "SSS ER"
  || header === "SSS EE"
  || header === "SSS Total"
  || header === "ECER"
  || header === "Total Contribution ER"
  || header === "Total Contribution EE"
  || header === "Total Contribution Total"
  || header === "SE Total Contribution"
  || header === "Salary Range From"
  || header === "Salary Range To"
  || header === "Total Monthly Premium"
  || header === "Percentage"
  || header === "Amount"
  || header === "Total Loan"
  || header === "Total Balance"
  || header === "Default Deduction"
  || header === "Allowance"
  || header === "Daily Salary"
  || header === "Allowance"
  || header === "Total Basic"
  || header === "Rate"
  || header === "Hours OT Regular"
  || header === "Total OT Regular"
  || header === "Hours OT Exceeded"
  || header === "Total OT Exceeded"
  || header === "Hours OT Restday"
  || header === "Total OT Restday"
  || header === "Hours Holiday Special"
  || header === "Total Holiday Special"
  || header === "Hours Holiday Regular"
  || header === "Total Holiday Regular"
  || header === "Hours Restday Holiday Special"
  || header === "Total Restday Holiday Special"
  || header === "Hours Restday Holiday Regular"
  || header === "Total Restday Holiday Regular"
  || header === "Additions"
  || header === "SSS"
  || header === "Pagibig"
  || header === "Philhealth"
  || header === "SSS Loan"
  || header === "SSS Calamity Loan"
  || header === "Pagibig Loan"
  || header === "Pagibig Calamity Loan"
  || header === "Tax"
  || header === "Deductions"
  || header === "Adjustments"
  || header === "Total Net Pay"
  || header === "Days Absent"
  || header === "Absent/s"
  || header === "Days Leave"
  || header === "Leave/s"
  || header === "Hours Exceeded"
  || header === "Total Exceeded"
  || header === "Hours Undertime"
  || header === "Undertime"
  || header === "Hours Late"
  ){
      const value = _cell.render("Cell").props.value;

      // Check if value is a number
      const isNumber = typeof value === 'number';

      const numberWithCommasAndDecimal = (number) => {
          return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      };

      if(!isNumber){
          return (
              <td {..._cell.getCellProps()}> {
                  _cell.render("Cell")
                  }
              </td>
          )
      }

      const formattedNumber = numberWithCommasAndDecimal(value);

      return(
          <td>
              {formattedNumber}
          </td>
      )
  }

  return (
      <td {..._cell.getCellProps()}> {
          _cell.render("Cell")
          }
      </td>
  )
}
const Tooltip = ({ text, children }) => {
  const [show, setShow] = useState(false);

  const handleMouseEnter = () => {
      setShow(true);
  };

  const handleMouseLeave = () => {
      setShow(false);
  };

  return (
      <div style={{ position: 'relative', display: 'inline-block',zIndex:"1" }}>
          <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
          {children}
          </div>
          {show && (
          <div
              style={{
              position: 'absolute',
              top: '50%',
              left: '-50%',
              transform: 'translateX(-50%)',
              backgroundColor: 'white',
              color: 'gray',
              padding: '5px',
              borderRadius: '5px',
              pointerEvents: "none",
              boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
              }}
          >
              {text}
          </div>
          )}
      </div>
  );
};
function AddEditFormBeneficiary({isOpen, 
    onClose, 
    benefitId,
    setBenefitId,
    modalName,

    isActive, setIsActive,
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!benefitId){
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
        handleClose();
    };

    const handleClose = () => {
        onClose();
        setBenefitId("");
        setIsActive(false)
        setErrorState(false);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{modalName}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Benefit</div>
                            <div className="info-item-input">
                                <BenefitIdSelect benefitId={benefitId} setBenefitId={setBenefitId}/>
                            </div>
                            <span style={{
                                        visibility: !benefitId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item row" style={{alignItems:"center"}}>
                            <div className="info-item-label" style={{paddingRight:"10px"}}>Is Active?</div>
                            <div className="info-item-input">
                                <input type="checkbox" 
                                id="isActive-checkbox" 
                                className="checkbox" 
                                name="" 
                                checked={isActive}
                                onChange={(event)=>setIsActive(event.target.checked)}/>
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function DeleteForm({isOpen, 
    onClose, 
    handleDelete}
){
  const handleSubmit = () => {
    handleDelete()
    handleClose()
  }
  const handleClose = () => {
      onClose();
  };

  return (
      <>
          <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
              {isOpen && (
              <div className="modal">
                  <div className="popUp-header row">
                      <div className="popUp-title">
                          <h3 style={{ color: "#668fca" }}>Delete!</h3>
                      </div>
                      <div className="popUp-close">
                          <CloseIcon onClick={()=>handleClose()} />
                      </div>
                  </div>
                  <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                      <span>Are you sure you want to delete this employee?</span>
                  </div>
                  <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                      <button id="add-family" 
                          className="save row"
                          onClick={handleSubmit}
                          style={{marginRight:"5px"}}>
                              DELETE
                      </button>
                      <button id="add-family" 
                          className="cancel row"
                          onClick={()=>handleClose()}>
                              CANCEL
                      </button>
                  </div>
              </div>
          )}
          </div>
      </>
  );
}
function QRCodeForm({isOpen, 
    onClose, 
    qrValue
    }
){
  const handleClose = () => {
      onClose();
  };

  const download = () => {
    // Find the canvas element generated by QRCodeCanvas
    const canvas = document.querySelector('canvas');
    if (!canvas) return;

    // Convert the canvas content to a downloadable PNG file
    const pngUrl = canvas
      .toDataURL('image/png') // create base64 image
      .replace('image/png', 'image/octet-stream'); // force download

    // Create a temporary link element
    const downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;

    // Optional: include something in filename from qrValue (if possible)
    const fileName = `qr-code-${Date.now()}.png`;
    downloadLink.download = fileName;

    // Trigger the download
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
      <>
          <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
              {isOpen && (
              <div className="modal">
                  <div className="popUp-header row">
                      <div className="popUp-title">
                          <h3 style={{ color: "#668fca" }}>QR Code</h3>
                      </div>
                      <div className="popUp-close">
                          <CloseIcon onClick={()=>handleClose()} />
                      </div>
                  </div>
                  <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                    <QRCodeCanvas
                      value={qrValue}
                      size={180}
                      bgColor="#ffffff"
                      fgColor="#000000"
                      level="H"
                    />
                  </div>
                  <div className="buttons row" style={{gap: "5px", justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                      <button id="add-family" 
                          className="save row"
                          onClick={download}>
                              DOWNLOAD
                      </button>
                      <button id="add-family" 
                          className="cancel row"
                          onClick={handleClose}>
                              CANCEL
                      </button>
                  </div>
              </div>
          )}
          </div>
      </>
  );
}
function BenefitIdSelect({benefitId, setBenefitId}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setBenefitId(event.target.value);
    };

    const [benefitIds, setBenefitIds] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Benefit/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setBenefitIds(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(benefitId !== "" && benefitId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [benefitId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={benefitId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose benefit</option>
            {benefitIds.map((benefitId) => ( 
                SetBenefitId(benefitId)
            ))}
            </select>
        </div>
    );
};
function SetBenefitId(benefitId){
    return(
        <option id={"leaveType" + benefitId.id} value={benefitId.id}>{
            benefitId.name}
        </option>
    )
    
}

const AddUpdateRequirementModal = ({ visible, onClose, onSave, modalName,
  data,
  onBoardingRequirements, setOnBoardingRequirements,
  file, setFile,
  hasCompleted, setHasCompleted,
  isActive, setIsActive,
}) => {
  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
      if (showRequestMessage) {
          const timeoutId = setTimeout(() => {
              setShowRequestMessage(false);
          }, 5000);

          return () => clearTimeout(timeoutId);
      }
      
  }, [showRequestMessage]);
  function GenerateMessage({form, message, isSuccess}){
      return (
          <>
              <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                  {form && (
                  <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                      <div className='column'>
                          {isSuccess ?
                              <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                  <CheckCircleIcon/>
                                  <span >{"SUCCESS MESSAGE"}</span>
                              </div>
                              :
                              <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                  <ErrorIcon/>
                                  <span>{"ERROR MESSAGE"}</span>
                              </div>
                          }
                          <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                      </div>
                  </div>
              )}
              </div>
          </>
      );
  }
  //Request Messages -end

  // for upload
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setFile(file);
  };

  if (!visible) return null;

  const handleSubmit = async () => {
    if(!onBoardingRequirements){
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage(`Please fill up required field/s.`);
      return;
    }

    await onSave();
    closeModal();
  };

  const resetLocalVariables = () => {
    setShowRequestMessage(false)
  }

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  }

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center text-gray-600 z-[3001]">
        <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
          <h2 className="text-2xl font-semibold mb-4">{modalName}</h2>

          <div className="space-y-5 mt-10 max-h-[500px] overflow-y-auto short:max-h-[300px] medium:h-[400px]">
            <div>
              <label className="block text-sm font-medium mb-1">
                Requirements <span className="text-red-500">*</span>
              </label>

              <div>
                <OnBoardingRequirementsSelect data={onBoardingRequirements} setData={setOnBoardingRequirements} isEditable={true} hasAll={false}/>
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">
                File
              </label>
              <div className="info-item-input">
                  <label htmlFor="file-input" className='column' style={{
                      color: "#808080b5",
                      fontSize: "14px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer" // Add cursor pointer for better user interaction
                  }}>
                      {!file && <img src={"images/upload-image.png"} alt="" style={{width: "auto", height: "200px"}}></img>}
                      {file ? file.name : "Click the placeholder to upload a logo"}
                  </label>
                  <input
                      id="file-input"
                      type="file"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                  />
              </div>
              <span style={{
                    visibility: "hidden",
                    color:"#ff6565", 
                    fontSize:"12px"}}>Please fill up this field
              </span>

              {file &&
              <>
                <div className='w-full'>
                  <button
                    className={"bg-blue-500 hover:bg-blue-600 border-none cursor-pointer p-1 px-2 text-white my-1 rounded-sm"}
                    onClick={() => {
                      const url = URL.createObjectURL(file); // create a blob URL
                      const link = document.createElement("a");
                      link.href = url;
                      link.download = file.name || "download"; // use file name if available
                      link.click();
                      URL.revokeObjectURL(url); // cleanup
                    }}
                  >
                    View File
                  </button>
                </div>
              </>}
            </div>
            <div>
              <label className="inline-flex items-center text-sm font-medium mb-1">
                <input
                  type="checkbox"
                  checked={hasCompleted}
                  onChange={(e) => setHasCompleted(e.target.checked)}
                  className="mr-2"
                />
                Has Completed?
              </label>
            </div>
            <div>
              <label className="inline-flex items-center text-sm font-medium mb-1">
                <input
                  type="checkbox"
                  checked={isActive}
                  onChange={(e) => setIsActive(e.target.checked)}
                  className="mr-2"
                />
                Is Active?
              </label>
            </div>
          </div>

          <div className="flex justify-end space-x-2 mt-6">
            <button
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition border-none cursor-pointer"
              onClick={handleSubmit}
            >
              Save
            </button>
            <button
              className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition border-none cursor-pointer"
              onClick={closeModal}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>

      <GenerateMessage form={showRequestMessage}
              message={requestMessage}
              isSuccess={isSuccess}
      > 
      </GenerateMessage>
    </>
  );
};
export default ViewEmployee
